<div class="header bg-gradient-danger pb-1 pt-5 pt-md-8">
  <div class="container-fluid">
    <div class="header-body"></div>
  </div>
</div>
<div class="container-fluid" style="margin-top: -4.1em">
  <!-- Icons is Used as Admin -->
  <mat-tab-group dynamicHeight [(selectedIndex)]="demo1TabIndex" (selectedTabChange)="onTabClick($event)" #tabGroup>
    <mat-tab label="Pending Credit Voucher">
      <div class="add-new-subscriber1 mat-elevation-z4">
        <div style="margin-top: 2%">
          <form [formGroup]="voucherform">
            <mat-form-field appearance="fill" style="margin-top: 1%; width: 30%;">
              <mat-label>Credit Voucher Date</mat-label>
              <mat-date-range-input [formGroup]="pendingvoucherForm" [rangePicker]="pickerpndg" [min]="financialYearMin"
                [max]="financialYearMax">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDatependingvoucher()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerpndg"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerpndg></mat-date-range-picker>

              <mat-error *ngIf="
                  pendingvoucherForm.controls.start.hasError(
                    'matStartDateInvalid'
                  )
                ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                  pendingvoucherForm.controls.end.hasError('matEndDateInvalid')
                ">Invalid end date
              </mat-error>
            </mat-form-field>

            <!-- Old Dropdown  -->
            <!-- <mat-form-field appearance="fill" class="example-full-width" style="margin-left: 3%">
              <mat-label>Representative</mat-label>
              <input matInput formControlName="rep" [matAutocomplete]="autorep2" />
              <button *ngIf="rep1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_rep1()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete autoActiveFirstOption #autorep2="matAutocomplete">
                <mat-option (onSelectionChange)="get_rep1($event, option)"
                  *ngFor="let option of filteredOptions12 | async" [value]="option['rep_name']">
                  {{ option["rep_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->

            <mat-form-field appearance="fill" class="example-full-width" style="margin-left: 1%">
              <mat-label>Representative</mat-label>
              <mat-select formControlName="rep" multiple>
                <mat-option (click)="toggleAllSelection17()" [value]="'ALL'">
                  <mat-pseudo-checkbox class="mat-option-pseudo-checkbox" [state]="(rep1Selected?.length || 0) === (GetOffRep?.length || 0) ? 'checked' : (rep1Selected?.length || 0) > 0
    ? 'indeterminate' : 'unchecked'">
                  </mat-pseudo-checkbox>
                  Select All
                </mat-option>
                <mat-option *ngFor="let option of GetOffRep" [value]="option.rep_name"
                  (onSelectionChange)="get_rep1($event, option)">
                  {{ option.rep_name }}
                </mat-option>
              </mat-select>
              <button *ngIf="rep1Selected.length" matSuffix mat-icon-button aria-label="Clear"
                (click)="clearSelection()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <!-- Old Dropdown  -->
            <!-- <mat-form-field appearance="fill" class="example-full-width" style="margin-left: 3%">
              <mat-label>Voucher No</mat-label>
              <input matInput formControlName="voucher_no" [matAutocomplete]="autovoucherno" />
              <button *ngIf="voucher_no1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_voucher_no()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete autoActiveFirstOption #autovoucherno="matAutocomplete">
                <mat-option (onSelectionChange)="get_voucher_no($event, option)"
                  *ngFor="let option of filteredOptions13 | async" [value]="option['voucher_no']">
                  {{ option["voucher_no"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->


            <mat-form-field appearance="fill" class="example-full-width" style="margin-left: 1%">
              <mat-label>Voucher No</mat-label>
              <mat-select formControlName="voucher_no" multiple>
                <mat-option (click)="toggleAllVoucherSelection()"
                  [class.selected]="voucherform.get('voucher_no')?.value?.length === voucher_no_data.length">
                  Select All
                </mat-option>
                <mat-option *ngFor="let option of voucher_no_data" [value]="option.voucher_no"
                  (onSelectionChange)="get_voucher_no($event, option)">
                  {{ option.voucher_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>



            <!-- <mat-form-field appearance="fill" class="example-full-width" style="margin-left: 3%">
          <mat-label>Office Package Name</mat-label>
          <input matInput formControlName="advt" [matAutocomplete]="autorep3" />
          <button *ngIf="pack1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_OfficePackage()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete autoActiveFirstOption #autorep3="matAutocomplete">
            <mat-option (onSelectionChange)="get_OfficePackage($event, $event.option.value)" 
            *ngFor="let option of filteredOptions29 | async" [value]="option">
              {{ option.advtName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field> -->

            <!-- Old Dropdown  -->
            <!-- <mat-form-field appearance="fill" class="example-full-width" style="margin-left: 3%">
          <mat-label>Package Name</mat-label>
          <input matInput formControlName="pkg" [matAutocomplete]="autorep4" />
          <button *ngIf="pack2" matSuffix mat-icon-button aria-label="Clear" (click)="reset_Package()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete autoActiveFirstOption #autorep4="matAutocomplete">
            <mat-option (onSelectionChange)="get_Package($event, option)" 
            *ngFor="let option of filteredOptions30 | async" [value]="option['pkg_name']">
              {{ option["pkg_name"] }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field> -->


            <mat-form-field appearance="fill" class="example-full-width" style="margin-left: 1%">
              <mat-label>Package Name</mat-label>
              <mat-select formControlName="pkg" multiple>
                <mat-option (click)="toggleAllSelectionPackage()" [value]="'ALL'">
                  <mat-pseudo-checkbox class="mat-option-pseudo-checkbox"
                    [state]="packageSelected.length === voucher_package_data.length ? 'checked' : packageSelected.length > 0 ? 'indeterminate' : 'unchecked'">
                  </mat-pseudo-checkbox>
                  Select All
                </mat-option>
                <mat-option *ngFor="let option of voucher_package_data" [value]="option.pkg_name"
                  (onSelectionChange)="get_Package($event, option)">
                  {{ option.pkg_name }}
                </mat-option>
              </mat-select>
              <button *ngIf="packageSelected.length" matSuffix mat-icon-button aria-label="Clear"
                (click)="clearPackageSelection()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

               <mat-form-field appearance="fill" style="margin-left: 1%; width: 30%;">
              <mat-label>Account Date</mat-label>
              <mat-date-range-input [formGroup]="pendingvoucherForm" [rangePicker]="entryPicker" [min]="financialYearMin"
                [max]="financialYearMax">
                <input matStartDate formControlName="start1" placeholder="Start date" />
                <input matEndDate formControlName="end1" placeholder="End date"
                  (dateChange)="getChangedDatependingvoucherAccountDate()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="entryPicker"></mat-datepicker-toggle>
              <mat-date-range-picker #entryPicker></mat-date-range-picker>

              <mat-error *ngIf="
                  pendingvoucherForm.controls.start1.hasError(
                    'matStartDateInvalid'
                  )
                ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                  pendingvoucherForm.controls.end1.hasError('matEndDateInvalid')
                ">Invalid end date
              </mat-error>
            </mat-form-field>

            <button class="noPrint" style="margin-top: -1%; margin-left: 5%;" mat-raised-button color="primary"
              printSectionId="print-section" [useExistingCss]="true" ngxPrint>
              Print
            </button>
            <button class="noPrint" style="margin-top: -1%; margin-left: 2%"
              (click)="exportExcel('Pending_credit_vocuher')" mat-raised-button color="primary">
              Export
            </button>
          </form>
        </div>
        <div style="margin-top: 20px;" class="tableFixHead" id="print-section">
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th class="btn-hide">Action</th>
                <th>Sr.No.</th>
                <th>Voucher No.</th>
                <th>Account Entry Date</th>
                <th class="btn-hide">Voucher Date</th>
                <th>Rep.Name</th>
                <th>Subscription Name</th>
                <th>Package Name</th>
                <th>Amount</th>
                <th>Remaining Amount</th>
                <th class="btn-hide">Cheque no</th>
                <th class="btn-hide">Cheque date</th>
                <!-- <th class="btn-hide">Entry Date</th> -->
                <th class="btn-hide">Bank Name</th>
                <th class="btn-hide">Branch Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="
                  let book of FilerterdgetallVouchersData;
                  let i = index
                ">
                <td class="btn-hide">
                  <button type="button" class="btn btn-danger btn-sm  " (click)="displayItemId(book)">
                    Mark as Completed
                  </button>
                </td>
                <td>{{ i + 1 }}</td>
                <td>{{ book["voucher_no"] }}</td>
                <td>{{ book["entry_date"] | date:'dd/MM/yyyy' }}</td>
                <td class="btn-hide">{{ book["voucher_date"] | date:'dd/MM/yyyy' }}</td>
                <td>{{ book["rep_name"] }}</td>
                <td>{{ book["advtName"] }}</td>
                <td><span *ngIf="book['pkg_name'] != 'N'">{{ book['pkg_name'] }}</span></td>
                <td> {{ book["price"] }}</td>
                <td> {{ book["remaining_amt"] }}</td>
                <td class="btn-hide">
                  <span *ngIf="book['cheque_no'] != 0">
                    {{ book["cheque_no"] }}
                  </span>
                  <span *ngIf="book['cheque_no'] == 0">-</span>
                </td>
                <td class="btn-hide">
                  <span *ngIf="book['cheque_no'] != 0">
                    {{ book["chequeDate"] | date: "dd-MM-yyy" }}
                  </span>
                  <span *ngIf="book['cheque_no'] == 0">-</span>
                </td>
                <!-- <td class="btn-hide">{{ book["entry_date"] }}</td> -->
                <td class="btn-hide">{{ book["bank"] }}</td>
                <td class="btn-hide">{{ book["branch_name"] }}</td>
              </tr>
              <tr>
                <td colspan="8"></td>
                <td>{{ this.total_amount }}</td>
                <td>{{ this.total_remaining_amt }}</td>
                <td colspan="4"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Subscription Registration">
      <mat-card class="sub" style="margin-top: 20px">
        <!-- (ngSubmit)="addsub()" -->
        <form class="form" [formGroup]="subform">
          <div class="form-row">
            <mat-form-field appearance="outline" class="example-full-width"
              style="width: 24%; margin-left: 5%; margin-top: 10px">
              <mat-label>Subscribers Name</mat-label>
              <input matInput formControlName="subname" (keyup)="getSubNames($event)" [matAutocomplete]="auto1" />
              <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name($event, option)" *ngFor="let option of sub_data"
                  [value]="option['subname']">
                  {{ option["subname"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <span>OR</span>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 16%; margin-top: 10px">
              <mat-label>Subscribers No</mat-label>
              <input matInput formControlName="subno" (keyup)="getSubNo($event)" [matAutocomplete]="auto2" />
              <mat-autocomplete autoActiveFirstOption #auto2="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name($event, option)" *ngFor="let option of sub_no"
                  [value]="option['subno']">
                  {{ option["subno"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <span>OR</span>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 20%; margin-top: 10px"
              [style.color]="validmobile ? null : 'red'">
              <mat-label>Mobile</mat-label>
              <input type="tel" #mobiles1 maxlength="10" formControlName="mobileNumber" (keyup)="getSubMobileNo($event)"
                [matAutocomplete]="auto" matInput />
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name($event, option)" *ngFor="let option of sub_mob_no"
                  [value]="option['mobno']">
                  {{ option["mobno"] }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint align="end">{{ mobiles1.value.length }} / 10</mat-hint>
              <mat-error *ngIf="validmobile">
                Please enter a valid mobile no.
              </mat-error>
              <mat-error *ngIf="validmobile">
                Mobile no. is <strong>required</strong>
              </mat-error>
            </mat-form-field>

            <button type="button" (click)="enableDisableRule('first')" [ngStyle]="{
              'background-color': toggle ? 'skyblue' : '#ddc05f'
            }" style="
              width: 8%;
              margin-left: 4.3%;
              height: 09vh;
              margin-top: 10px;
              
            ">
              Renewal
            </button>
            <button type="button" (click)="enableDisableRule('second')" [ngStyle]="{
              'background-color': toggle1 ? 'skyblue' : '#ddc05f'
            }" style="width: 8%; height: 09vh; margin-top: 10px;">
              New
            </button>
            <!-- <button type="button" (click)="enableDisableRule('third')" [ngStyle]="{
              'background-color': toggle2 ? 'skyblue' : '#ddc05f'
            }" style="width: 11.3%; height: 06vh;">
            Cancel
          </button> -->
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" class="example-full-width" style="width: 26%; margin-left: 5%">
              <mat-label>Name</mat-label>
              <input matInput formControlName="showname" />
            </mat-form-field>
            <!-- <button type="button" (click)="enableDisableRule('first')" [ngStyle]="{
                'background-color': toggle ? 'skyblue' : '#ddc05f'
              }" style="
                width: 12%;
                margin-left: 4.3%;
                height: 06vh;
                
              ">
              Renewal
            </button>
            <button type="button" (click)="enableDisableRule('second')" [ngStyle]="{
                'background-color': toggle1 ? 'skyblue' : '#ddc05f'
              }" style="width: 12%; height: 06vh;">
              New
            </button>
            <button type="button" (click)="enableDisableRule('third')" [ngStyle]="{
                'background-color': toggle2 ? 'skyblue' : '#ddc05f'
              }" style="width: 11.3%; height: 06vh;">
              Cancel
            </button> -->
            <!-- <mat-checkbox style="margin-left: 1%" formControlName="iscomplimentary" [checked]="iscomplementary"
            (change)="complementry($event.checked)">Complemenatry</mat-checkbox> -->

            <mat-form-field appearance="outline" class="example-full-width" style="width: 14%; margin-left: 1%;">
              <mat-label>Sub Type</mat-label>
              <input matInput formControlName="subtype" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 8%; margin-left: 1%;">
              <mat-label>MM</mat-label>
              <input matInput formControlName="month" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 8%; margin-left: 1%;">
              <mat-label>YY</mat-label>
              <input matInput formControlName="year" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 12%; margin-left: 1%;">
              <mat-label>Subscribers No</mat-label>
              <input matInput formControlName="subno" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="width: 15%; margin-left: 1%;">
              <mat-label>Dispatch Date</mat-label>
              <input matInput [value]="isValidDate(publishDateCalculated) ? publishDateCalculated : ''" readonly />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field style="width: 11%; margin-left: 5%" appearance="outline">
              <mat-label>Title</mat-label>
              <mat-select formControlName="title" [(ngModel)]="title" (selectionChange)="autoTranslateField('title')">
                <mat-option *ngFor="let c of titles" value="{{ c['title'] }}">{{
                  c["title"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="width: 11%; margin-left: 1%">
              <mat-label>Title (In English)</mat-label>
              <input matInput formControlName="e_title" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="width: 32%; margin-left: 0.5%"
              [style.color]="validatefname ? null : 'red'">
              <mat-label>Name</mat-label>
              <input matInput (change)="validateName($event)" formControlName="name" required
                (input)="autoTranslateField('name')" />

              <mat-error *ngIf="validatefname">
                Please enter a valid name
              </mat-error>
              <mat-error *ngIf="validatefname">
                Name is <strong>required</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="width: 32%; margin-left: 1%">
              <mat-label>Name (In English)</mat-label>
              <input matInput formControlName="e_name" />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field class="example-full-width" style="width: 48%; margin-left: 5%" appearance="outline">
              <mat-label>Address</mat-label>
              <textarea matInput placeholder="Address" formControlName="address" required rows="3"
                (input)="autoTranslateField('address')"></textarea>
            </mat-form-field>

            <div style="display: flex; flex-direction: column; width: 40%; margin-left: 1%;">
              <mat-form-field class="example-full-width" style="width: 98%; margin-left: 1%; " appearance="outline">
                <mat-label>Address (In English)</mat-label>
                <textarea matInput placeholder="Address In English" formControlName="e_address" rows="1"></textarea>
              </mat-form-field>

              <mat-form-field class="example-full-width" style="width: 98%; margin-left: 1%; margin-top: -5%;"
                appearance="outline">
                <mat-label>Address1 (In English)</mat-label>
                <textarea matInput placeholder="Address 1 In English" formControlName="e_address1" rows="1"></textarea>
              </mat-form-field>

              <mat-form-field class="example-full-width" style="width: 98%; margin-left: 1%; margin-top: -5%;"
                appearance="outline">
                <mat-label>Address2 (In English)</mat-label>
                <textarea matInput placeholder="Address 2 In English" formControlName="e_address2" rows="1"></textarea>
              </mat-form-field>

            </div>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 5%; width: 10%" class="example-full-width" appearance="outline">
              <mat-label>Pincode</mat-label>
              <input (change)="getPincode1($event)" matInput #postalCode maxlength="6" placeholder=""
                formControlName="pincode" (input)="autoTranslateField('pincode')" />
              <mat-hint align="end">{{ postalCode.value.length }} / 6</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="width: 10%; margin-left: 1%">
              <mat-label>Pincode (In English)</mat-label>
              <input matInput formControlName="e_pincode" />
            </mat-form-field>

            <mat-form-field style="width: 15%; margin-left: 1%" appearance="outline">
              <mat-label>Country</mat-label>
              <mat-select (selectionChange)="getCountry($event); autoTranslateField('country')"
                formControlName="country">
                <mat-option *ngFor="let c of countries" value="{{ c['country_name'] }}">{{ c["country_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="width: 15%; margin-left: 1%">
              <mat-label>Country (In English)</mat-label>
              <input matInput formControlName="e_country" />
            </mat-form-field>

            <mat-form-field style="width: 17%; margin-left: 1%" appearance="outline">
              <mat-label>State</mat-label>
              <mat-select (selectionChange)="getState($event); autoTranslateField('state')" formControlName="state">
                <mat-option *ngFor="let c of states" value="{{ c['state_name'] }}">{{ c["state_name"] }}
                </mat-option>
              </mat-select>
              <span>{{ selectedState }}</span>
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="width: 17%; margin-left: 1%">
              <mat-label>State (In English)</mat-label>
              <input matInput formControlName="e_state" />
            </mat-form-field>

          </div>

          <div class="form-row">
            <mat-form-field style="width: 21%; margin-left: 5%" appearance="outline">
              <mat-label>District</mat-label>
              <mat-select (selectionChange)="getDistricts($event); autoTranslateField('district')"
                formControlName="district">
                <mat-option *ngFor="let c of cities" value="{{ c['district_name'] }}">{{ c["district_name"] }}
                </mat-option>
              </mat-select>
              <span>{{ selectedCity }}</span>
            </mat-form-field>

            <mat-form-field style="margin-left: 1%; width: 21%" class="example-full-width" appearance="outline">
              <mat-label>District (In English)</mat-label>
              <input matInput type="text" placeholder="" formControlName="e_district" />
            </mat-form-field>

            <mat-form-field style="width: 21%; margin-left: 2%" appearance="outline">
              <mat-label>Taluka</mat-label>
              <mat-select (selectionChange)="getTaluka($event); autoTranslateField('taluka')" formControlName="taluka">
                <mat-option *ngFor="let c of talukas" value="{{ c['taluka_name'] }}">{{ c["taluka_name"] }}</mat-option>
              </mat-select>
              <span>{{ selectedTaluka }}</span>
            </mat-form-field>

            <mat-form-field style="margin-left: 1%; width: 22%" class="example-full-width" appearance="outline">
              <mat-label>Taluka (In English)</mat-label>
              <input matInput type="text" placeholder="" formControlName="e_taluka" />
            </mat-form-field>
          </div>


          <div class="form-row">
            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 5%; width: 21%"
              [style.color]="validmobile ? null : 'red'">
              <mat-label>Mobile</mat-label>
              <span matPrefix>+91 &nbsp;</span>
              <input type="tel" #mobiles (change)="validateMobile($event)" maxlength="10" formControlName="mobileNumber"
                matInput />
              <mat-hint align="end">{{ mobiles.value.length }} / 10</mat-hint>
              <mat-error *ngIf="validmobile">
                Please enter a valid mobile no.
              </mat-error>
              <mat-error *ngIf="validmobile">
                Mobile no. is <strong>required</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="example-full-width" appearance="outline" style="width: 22%; margin-left: 1%">
              <mat-label>Telephone</mat-label>
              <input matInput type="number" formControlName="telephone" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="width: 26%; margin-left: 1%"
              [style.color]="validemail ? null : 'red'">
              <mat-label>Email</mat-label>
              <input (change)="validateEmail($event)" type="email" matInput formControlName="email"
                placeholder="Ex. pat@example.com" />
              <mat-error *ngIf="validemail">
                Please enter a valid email address
              </mat-error>
              <mat-error *ngIf="validemail">
                Email is <strong>required</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-left: 2%; width: 16%">
              <mat-label>Date of Birth</mat-label>
              <input formControlName="dob" matInput type="date" />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 5%; width: 12%">
              <mat-label>Marriage Date</mat-label>
              <input formControlName="doa" matInput type="date" />
            </mat-form-field>

            <mat-form-field class="example-full-width" appearance="outline" style="width: 22%; margin-left: 1%">
              <mat-label>Representative Name</mat-label>
              <input matInput formControlName="repname" [matAutocomplete]="autore" />
              <mat-autocomplete autoActiveFirstOption #autore="matAutocomplete">
                <mat-option (onSelectionChange)="selected_rep1_name($event, option)"
                  *ngFor="let option of filteredOptions4 | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 1%; width: 14%"
              [style.color]="validmobile ? null : 'red'">
              <mat-label>Representative Mobile No</mat-label>
              <span matPrefix>+91 &nbsp;</span>
              <input type="tel" #m (change)="validateMobile($event)" maxlength="10" formControlName="repmobno"
                matInput />
              <mat-hint align="end">{{ m.value.length }} / 10</mat-hint>
              <mat-error *ngIf="validmobile">
                Please enter a valid mobile no.
              </mat-error>
              <mat-error *ngIf="validmobile">
                Mobile no. is <strong>required</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="example-full-width" appearance="outline" style="width: 17%; margin-left: 1%">
              <mat-label>GST No</mat-label>
              <input matInput formControlName="gst_no" />
            </mat-form-field>

            <mat-form-field class="example-full-width" appearance="outline" style="width: 20%; margin-left: 1%">
              <mat-label>Remark</mat-label>
              <input matInput formControlName="remark" />
            </mat-form-field>
          </div>

          <div class="form-row" *ngIf="selectedname">
            <button style="
                margin-left: 20%;
                width: 40%;
              " type="button" (click)="updatesubscriber()" mat-raised-button color="primary"
              class="btn btn-primary btn-block">
              Update
            </button>
            <button style="margin-left: 2%;width: 20%;" type="button" (click)="deletesubscriber()" mat-raised-button
              color="danger" class="btn btn-danger btn-block">
              Delete
            </button>
          </div>

          <div class="form-row" style="
              justify-content: center;
              background-color: #8bbdbd;
              margin-bottom: 2%;
              margin-top: 2%;
            ">
            <h2 style="text-align: center; margin-top: 10px; color: black">
              Subscription Details
            </h2>
          </div>

          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Current Representative Name</mat-label>
              <input matInput formControlName="crepname" [matAutocomplete]="autorep" />
              <mat-autocomplete autoActiveFirstOption #autorep="matAutocomplete">
                <mat-option (onSelectionChange)="selected_rep_name($event, option)"
                  *ngFor="let option of filteredOptions3 | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 5%; width: 35%"
              [style.color]="validmobile ? null : 'red'">
              <mat-label>Representative Mobile No</mat-label>
              <span matPrefix>+91 &nbsp;</span>
              <input type="tel" #m1 (change)="validateMobile($event)" maxlength="10" formControlName="repmobno1"
                matInput />
              <mat-hint align="end">{{ m1.value.length }} / 10</mat-hint>
              <mat-error *ngIf="validmobile">
                Please enter a valid mobile no.
              </mat-error>
              <mat-error *ngIf="validmobile">
                Mobile no. is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 5%; width: 35%">
              <mat-label>Office Representative</mat-label>
              <input matInput formControlName="officerep" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 5%; width: 35%">
              <mat-label>VoucherId</mat-label>
              <input matInput formControlName="voucherid" />
            </mat-form-field>
          </div>

          <div class="form-row" *ngIf="!iscomplementary">
            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 5%; width: 23%">
              <mat-label>CR. Voucher Date</mat-label>
              <input matInput formControlName="crdtdate" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 23%; margin-left: 3%">
              <mat-label>CR. Voucher No:</mat-label>
              <input matInput formControlName="crdtvno" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 23%; margin-left: 3%">
              <mat-label>Receipt No.</mat-label>
              <input matInput formControlName="rep_receipt" />
            </mat-form-field>
          </div>

          <div class="form-row" *ngIf="!iscomplementary">
            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 5%; width: 23%">
              <mat-label>Credit Voucher Amount</mat-label>
              <input matInput formControlName="crdtamt" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 23%; margin-left: 3%">
              <mat-label>Select Entry Amount</mat-label>
              <input matInput formControlName="seamt" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 23%; margin-left: 3%">
              <mat-label>Balance Amount</mat-label>
              <input matInput formControlName="balamt" readonly />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
              <mat-label>Entry Date</mat-label>
              <input formControlName="entrydate" matInput type="date" readonly />
            </mat-form-field>

            <mat-checkbox style="margin-left: 1%" formControlName="iscomplimentary" [checked]="iscomplementary"
              (change)="complementry($event.checked)">Complemenatry</mat-checkbox>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
              <mat-label>Magazine Name</mat-label>
              <mat-select required (selectionChange)="getmagdetails($event)" formControlName="magnames">
                <mat-option *ngFor="let mags of magname" value="{{ mags['name'] }}">{{ mags["name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
              <mat-label>Edition </mat-label>
              <mat-select required (selectionChange)="getmagEdition($event)" formControlName="magedition">
                <mat-option value="Print">Print</mat-option>
                <mat-option value="Digital">Digital</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 28%; margin-left: 5%" *ngIf="!showNewSubscriptionType">
              <mat-label>Subscription Type</mat-label>
              <input matInput formControlName="duration" [matAutocomplete]="autodua" />
              <mat-autocomplete autoActiveFirstOption #autodua="matAutocomplete">
                <mat-option (onSelectionChange)="durationn($event, option)" *ngFor="let option of subscriptiontype "
                  [value]="option['subtype']">
                  {{ option["subtype"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="example-full-width" appearance="outline" style="width: 28%; margin-left: 5%" *ngIf="showNewSubscriptionType">
              <mat-label>Subscription Type</mat-label>
              <input matInput formControlName="duration1" [matAutocomplete]="autodua" />
              <mat-autocomplete autoActiveFirstOption #autodua="matAutocomplete">
                <mat-option (onSelectionChange)="durationn1($event, option)" *ngFor="let option of subscriptiontype "
                  [value]="option['subtype']">
                  {{ option["subtype"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-left: 1%; width: 17%">
              <mat-label>Subscription Year</mat-label>
              <input formControlName="subyear" matInput type="date" />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 5%; width: 23%">
              <mat-label>Subscription Period: From</mat-label>
              <input formControlName="subfromdate" matInput type="date" (change)="getDate()" />
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-left: 3%; width: 23%">
              <mat-label>To</mat-label>
              <input formControlName="subtodate" matInput type="date" />
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-left: 3%; width: 23%">
              <mat-label>Delivery Mode</mat-label>
              <mat-select required formControlName="distype">
                <mat-option *ngFor="let rep of delivery_mode" value="{{ rep['delivery_mode'] }}">{{ rep["delivery_mode"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <!-- New Extra Fields  -->
          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 5%; width: 23%">
              <mat-label>Subscription Period: From 1</mat-label>
              <input formControlName="subfromdate1" matInput type="date" (change)="getDate1()" />
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-left: 3%; width: 23%">
              <mat-label>To 1</mat-label>
              <input formControlName="subtodate1" matInput type="date" />
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-left: 3%; width: 23%">
              <mat-label>Delivery Mode 1</mat-label>
              <mat-select formControlName="distype1">
                <mat-option *ngFor="let rep of delivery_mode" value="{{ rep['delivery_mode'] }}">{{ rep["delivery_mode"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <div class="form-row">
            <label style="margin-left: 5%; margin-top: -20px">
              (Note-Magazin Will Start From Issue Date- )
            </label>
          </div>

          <div class="form-row">
            <!-- (selectionChange)="SelectRepresentative($event)" -->
            <!-- <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
              <mat-label>Delivery Mode</mat-label>
              <mat-select required formControlName="distype">
                <mat-option *ngFor="let rep of delivery_mode" value="{{ rep['delivery_mode'] }}">{{ rep["delivery_mode"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Distribution Representative</mat-label>
              <input matInput formControlName="disrep" [matAutocomplete]="autodis" />
              <mat-error *ngIf="subform.get('disrep')?.hasError('required')">
                <!-- Distribution Representative is Required. -->
                कृपया वितरण प्रतिनिधीचे नाव प्रविष्ट करा.
              </mat-error>
              <mat-autocomplete autoActiveFirstOption #autodis="matAutocomplete">
                <mat-option (onSelectionChange)="distribution($event, option)"
                  *ngFor="let option of filteredOptions6 | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="example-full-width" style="width: 35%; margin-left: 5%">
              <mat-label>Temp. Receipt No</mat-label>
              <input type="number" matInput formControlName="trecptno" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 35%; margin-left: 5%">
              <mat-label>Date</mat-label>
              <input matInput type="date" formControlName="rdate" />
              <!-- <mat-datepicker-toggle[matDatepicker]="d"
                matSuffix
                [for]="d"
              ></mat-datepicker-toggle>
              <mat-datepicker #d></mat-datepicker> -->
            </mat-form-field>
          </div>

          <div class="form-group" *ngIf="!iscomplementary">
            <label style="margin-left: 5%; width: 23%; font-weight: bold">Total Amount : {{ total }}</label>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 23%; margin-left: 3%">
              <mat-label>Discount</mat-label>
              <input matInput type="number" (change)="discountcal($event)" formControlName="discount" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 23%; margin-left: 3%">
              <mat-label>Net Amount:</mat-label>
              <input matInput type="number" formControlName="netamount" />
            </mat-form-field>
          </div>

          <div class="form-row" *ngIf="!iscomplementary">
            <label style="margin-left: 5%; font-weight: bold">
              Amount In Word - {{ this.totalamtinword }}
            </label>
          </div>

          <div class="form-row" *ngIf="!iscomplementary">
            <label style="margin-left: 5%; margin-top: 20px">Representative Commission:</label>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-left: 4%">
              <mat-label>%</mat-label>
              <input type="number" matInput formControlName="repcompercent" (change)="repcommission($event)" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-left: 4%">
              <mat-label>Amt.</mat-label>
              <input type="number" matInput formControlName="repcomprice" />
            </mat-form-field>
          </div>

          <div class="form-row" *ngIf="!iscomplementary">
            <label style="margin-left: 5%; font-weight: bold">Payment Details</label>
          </div>

          <div class="form-row" *ngIf="!iscomplementary">
            <mat-form-field appearance="outline" class="example-full-width" style="width: 35%; margin-left: 5%">
              <mat-label>Cheque/Draft No:</mat-label>
              <input matInput formControlName="cdno" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 35%; margin-left: 5%">
              <mat-label>Cheque Date</mat-label>
              <input matInput type="date" formControlName="chequeDate" />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field *ngIf="!iscomplementary" appearance="outline" class="example-full-width"
              style="width: 35%; margin-left: 5%">
              <mat-label>Bank Name:</mat-label>
              <input matInput formControlName="bankname" />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Remark</mat-label>
              <input matInput formControlName="subremark" />
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Remark_1</mat-label>
              <input matInput formControlName="subremark1" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Remark_2</mat-label>
              <input matInput formControlName="subremark2" />
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Employee ID</mat-label>
              <input matInput formControlName="emp_mob_number" readonly />
            </mat-form-field>
          </div>
          <div class="form-row" *ngIf="selectedrcpt">
            <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Receipt Active</mat-label>
              <select matNativeControl formControlName="isactive" (change)="isreceiptactive($event)">
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </select>
            </mat-form-field>
          </div>
          <div class="form-row" *ngIf="isrcptno">
            <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Days Added</mat-label>
              <input matInput type="number" formControlName="days" readonly />
            </mat-form-field>
          </div>
          <div class="form-row" *ngIf="isrcptno">
            <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Receipt Stop Date</mat-label>
              <input matInput type="date" formControlName="rcptstopdate" readonly />
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Remark</mat-label>
              <input matInput formControlName="rcptstopremark" />
            </mat-form-field>
          </div>

          <div class="form-row" *ngIf="isrcptno">
            <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Receipt Start Date</mat-label>
              <input matInput type="date" formControlName="rcptstartdate" />
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Remark</mat-label>
              <input matInput formControlName="rcptstartremark" readonly />
            </mat-form-field>
          </div>

          <div class="form-row" *ngIf="!selectedrcpt">
            <button style="margin-left: 10%; width: 25%" type="button" mat-raised-button color="primary"
              class="btn btn-primary btn-block" [disabled]="subform.invalid || +subform.get('balamt')?.value < 0"
              (click)="addsub()">
              Add Subscription
            </button>
            <button style="margin-left: 5%; width: 25%" type="button" (click)="updatesubscriberreceipt()"
              mat-raised-button color="primary" class="btn btn-primary btn-block">
              Update
            </button>
            <button style="margin-left: 2%;width: 20%;" type="button" (click)="deletesubscriberreceipt()"
              mat-raised-button color="danger" class="btn btn-danger btn-block">
              Delete
            </button>

          </div>
          <div class="form-row" *ngIf="selectedrcpt">
            <!-- <button style="margin-left: 10%; width: 25%" [disabled]="subform.invalid" type="button" mat-raised-button
              color="primary" class="btn btn-primary btn-block" (click)="addsub()">
              Add Subscription
            </button> -->
            <button style="margin-left: 5%; width: 25%" type="button" (click)="updatesubscriberreceipt()"
              mat-raised-button color="primary" class="btn btn-primary btn-block">
              Update
            </button>
            <button style="margin-left: 2%;width: 20%;" type="button" (click)="deletesubscriberreceipt()"
              mat-raised-button color="danger" class="btn btn-danger btn-block">
              Delete
            </button>
          </div>
        </form>
      </mat-card>
    </mat-tab>


    <mat-tab label="Subscriber Receipt Ledger">
      <mat-card style="display: flow;">
        <form [formGroup]="receiptLedger">

          <!-- <mat-form-field appearance="fill" style="width:300px">
          <mat-label>Select Date</mat-label>
          <input matInput [matDatepicker]="pickersubdate" [(ngModel)]="subdate" (ngModelChange)="selectSubDate()">
          <mat-datepicker-toggle matSuffix [for]="pickersubdate"></mat-datepicker-toggle>
          <mat-datepicker #pickersubdate></mat-datepicker>
        </mat-form-field> -->
          <mat-form-field appearance="fill" style="margin-top: 1%; width:30%;">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="pickerrtl" [min]="financialYearMin" [max]="financialYearMax">
              <input matStartDate formControlName="start" placeholder="Start date" />
              <input matEndDate formControlName="end" placeholder="End date"
                (dateChange)="getChangedDateRcptLedger()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerrtl"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerrtl></mat-date-range-picker>
          </mat-form-field>

          <mat-form-field appearance="fill" style="margin-top: 1%; margin-left: 1%">
            <mat-label>Customer Name</mat-label>
            <input type="text" matInput [(ngModel)]="cust_name" formControlName="cust_name"
              (keyup)="custname($event)" />
            <button *ngIf="cust_name" matSuffix mat-icon-button aria-label="Clear" (click)="reset_custname()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <button type="button" class="btn" mat-raised-button color="primary"
            style="float: none;margin-left: 2%; width: 250px;" (click)="subReceipt()">Subcriber
            Receipt</button>
        </form>
      </mat-card>
      <mat-card>
        <div class="form-row">
          <form [formGroup]="paymentreceiptledger">
            <mat-form-field appearance="fill" style="margin-left: 3%; margin-top: 1%; width: 20%;">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [rangePicker]="pickerrcpt" [min]="financialYearMin" [max]="financialYearMax">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateRcptLedger1()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerrcpt"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerrcpt></mat-date-range-picker>

              <mat-error *ngIf="
                        rcptldgrForm.controls.start.hasError('matStartDateInvalid')
                      ">Invalid start date
              </mat-error>
              <mat-error *ngIf="rcptldgrForm.controls.end.hasError('matEndDateInvalid')">Invalid end date
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" style="margin-top: 1%; margin-left: 3%;width: 20%;">
              <mat-label>Receipt No</mat-label>
              <input type="text" formControlName="rcpt_number" matInput [(ngModel)]="rcpt_no1"
                (ngModelChange)="rcptno($event)" />
              <button *ngIf="rcpt_no1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_rcptno()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <mat-form-field appearance="fill" style="margin-top: 1%; margin-left: 3%; width: 20%;">
              <mat-label>Represantative Name</mat-label>
              <mat-select formControlName="rep" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let option of GetOffRep" [value]="option['rep_name']">{{ option["rep_name"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field appearance="fill"  style="margin-top: 1%; margin-left: 1%; margin-right: 1%;">
                    <mat-label>District Name</mat-label>
                    <input matInput formControlName="dist_name" [matAutocomplete]="districtname" (selectionChange)="getDistricts($event)" />
                    <button *ngIf="sub_names1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_sub_names1()">
                      <mat-icon>close</mat-icon>
                    </button>
                    <mat-autocomplete autoActiveFirstOption #districtname="matAutocomplete">
                      <mat-option  *ngFor="let option of distname" [value]="option['district_name']">
                        {{ option["district_name"] }}
                      </mat-option>
                    </mat-autocomplete>
                    
                  </mat-form-field> -->
            <mat-form-field style="margin-left: 3%; margin-top: 1%; width: 20%;" appearance="fill">
              <mat-label>Country</mat-label>
              <mat-select (selectionChange)="getCountry($event)" formControlName="country" multiple>
                <mat-option *ngFor="let c of countries" value="{{ c['country_name'] }}">{{ c["country_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field style="margin-top: 5%; width: 20%;" appearance="fill">
              <mat-label>State</mat-label>
              <mat-select (selectionChange)="getStates($event)" formControlName="state" multiple>
                <mat-option *ngFor="let c of states" value="{{ c['state_name'] }}">{{ c["state_name"] }}
                </mat-option>
              </mat-select>
              <span>{{ selectedState }}</span>
            </mat-form-field> -->


            <mat-form-field style="margin-left: 3%; margin-top: 1%; width: 20%;" appearance="fill">
              <mat-label>State</mat-label>
              <mat-select (selectionChange)="getStates($event)" formControlName="state" multiple>
                <mat-option *ngFor="let c of states" [value]="c">
                  {{ c.state_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; margin-top: 1%; width: 20%;" appearance="fill">
              <mat-label>District</mat-label>
              <mat-select (selectionChange)="getDistricts($event)" formControlName="district" multiple>
                <mat-option *ngFor="let c of cities" value="{{ c['district_name'] }}">{{ c["district_name"] }}
                </mat-option>
              </mat-select>
              <span>{{ selectedCity }}</span>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; margin-top: 1%; width: 20%;" appearance="fill">
              <mat-label>Taluka</mat-label>
              <mat-select formControlName="taluka" multiple>
                <mat-option *ngFor="let c of talukas" value="{{ c['taluka_name'] }}">{{ c["taluka_name"] }}</mat-option>
              </mat-select>
              <span>{{ selectedTaluka }}</span>
            </mat-form-field>

            <!-- <mat-form-field appearance="fill" style="margin-top: 1%; margin-left: 3%; width: 20%;">
              <mat-label>Prant Name</mat-label>
              <input matInput formControlName="prant_name" [matAutocomplete]="prantname1" />
              <button *ngIf="sub_names1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_sub_names1()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete autoActiveFirstOption #prantname1="matAutocomplete">
                <mat-option *ngFor="let option of prantdata" [value]="option['prant_name']">
                  {{ option["prant_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->

            <mat-form-field appearance="fill" style="margin-top: 1%; margin-left: 3%; width: 20%;">
              <mat-label>Prant Name</mat-label>
              <mat-select formControlName="prant_name" multiple>
                <mat-select-trigger>
                  {{ (paymentreceiptledger.get('prant_name')?.value?.length ?
                  paymentreceiptledger.get('prant_name')?.value.join(', ') : '') }}
                </mat-select-trigger>
                <mat-option *ngFor="let option of prantdata" [value]="option['prant_name']">
                  {{ option["prant_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field appearance="fill" class="example-full-width" style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Prant Name</mat-label>
            <mat-select formControlName="prant_name" multiple>
              <mat-select-trigger>
                {{ (subdetailsform.get('prant_name')?.value || []).join(', ') }}
              </mat-select-trigger>
              <mat-option *ngFor="let option of prantdata" [value]="option['prant_name']">
                {{ option['prant_name'] }}
              </mat-option>
            </mat-select>
            <button *ngIf="subdetailsform.get('prant_name')?.value?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetPrant()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field> -->

            <mat-form-field style="margin-top: 1%; margin-left: 3%; width: 20%;" appearance="fill">
              <mat-label>Dis. Reprensantive</mat-label>
              <mat-select formControlName="dis_rep" multiple>
                <!-- <mat-option *ngFor="let c of dis_rep_data" value="{{ c['id'] }}">{{ c["distribution_rep"]
                  }}</mat-option> -->
                <mat-option *ngFor="let option of dis_rep_data" [value]="option['distribution_rep']">{{
                  option["distribution_rep"]
                  }}</mat-option>
              </mat-select>
              <span>{{ selectedTaluka }}</span>
            </mat-form-field>

            <mat-form-field class="fill" style="margin-left: 3%; margin-top: 1%; width: 20%;">
              <mat-label>Show New / Renew : </mat-label>
              <mat-select matNativeControl formControlName="rcpt_type" multiple>
                <mat-option [value]="'ALL'">All</mat-option>
                <mat-option [value]="'New'">New</mat-option>
                <mat-option [value]="'Renew'">Renew</mat-option>

              </mat-select>

            </mat-form-field>

          </form>

          <button type="button" class="btn " mat-raised-button color="primary"
            style="float: none;height: 44px;margin-left: 2%;margin-top: 2%; width: 250px;"
            (click)="searchpaymentreceipt()">Search
          </button>

          <button type="button" class="btn " mat-raised-button color="primary"
            style="float: none;height: 44px;margin-left: 2%;margin-top: 2%; width: 250px;"
            (click)="subReceiptLedger()">Subcriber Receipt List
          </button>

          <button type="button" class="btn " mat-raised-button color="primary"
            style="float: none;height: 44px;margin-left: 2%;margin-top: 2%; width: 250px;"
            (click)="subReceiptAddress()">Subscriber Receipt Address
          </button>

        </div>
        <div class="tableFixHead mt-3" style="height: 400px;" id="print-section1">
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th style="font-weight: bold; font-size: 14px;">अ.क्र.</th>
                <th style="font-weight: bold; font-size: 14px;">पावती क्र.</th>
                <th style="font-weight: bold; font-size: 14px;">दिनांक</th>
                <th style="font-weight: bold; font-size: 14px;">ग्राहक .क्र</th>
                <th style="font-weight: bold; font-size: 14px;">वर्गणीदार नाव</th>
                <th style="font-weight: bold; font-size: 14px;">ठिकाण</th>
                <th style="font-weight: bold; font-size: 14px;">वर्गणी प्रकार</th>
                <th style="font-weight: bold; font-size: 14px;">नवीन/नूतनीकरण</th>
                <th style="font-weight: bold; font-size: 14px;">वैद्य दिनांक</th>
                <th style="font-weight: bold; font-size: 14px;">प्रतिनिधी</th>
                <th style="font-weight: bold; font-size: 14px;">ऑफिस प्रतिनिधी</th>
                <th style="font-weight: bold; font-size: 14px;">वितरण प्रकार</th>
                <th style="font-weight: bold; font-size: 14px;">वितरण दिनांक</th>
                <th style="font-weight: bold; font-size: 14px;">रक्कम</th>
                <!-- <th>Discount</th> -->
                <th style="font-weight: bold; font-size: 14px;">ACTION</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Filetredreceiptledger; let i = index;">
                <td>{{i+1}}</td>
                <td>{{ item["rcpt_no"] }}</td>
                <!-- <td>{{ item["entry_date"] | date: "dd-MM-yyy" }}</td> -->
                <td>{{ item["crdt_voucher_date"] | date: "dd-MM-yyy" }}</td>
                <td>{{ item["subno"] }}</td>
                <td>{{ item["name"] }}</td>
                <td>{{ item["district"] }}</td>
                <td>{{ item["subscription_type"] }}</td>
                <td>{{ item["rcpt_type"] }}</td>
                <!-- <td>
                  {{ item["sub_perid_from_date"] | date: "dd-MM-yyy" }} -
                  {{ item["sub_perid_to_date"] | date: "dd-MM-yyy" }}
                </td> -->

                <td>
                  {{
                  (item['sub_perid_from_date1'] && item['sub_perid_from_date1'] !== '0000-00-00'
                  ? item['sub_perid_from_date1']
                  : item['sub_perid_from_date']) | date:'dd-MM-yyyy'
                  }}
                  -
                  {{
                  (item['sub_perid_from_date1'] && item['sub_perid_from_date1'] !== '0000-00-00'
                  ? item['sub_perid_to_date1']
                  : item['sub_perid_to_date']) | date:'dd-MM-yyyy'
                  }}
                </td>


                <td>{{ item["rep_name"] }}</td>
                <td>{{ item["office_rep_name"] }}</td>
                <td>{{ item["delivery_mode"] }}</td>
                <td>{{ item["publish_date"] }}</td>

                <td>{{ item["total_amt"] }}</td>
                <!-- <td>{{ item["discount"] }}</td> -->
                <td> <button style="margin-left: 2%;width: 20%;" type="button" (click)="deletesubscriberrcpt(item)"
                    mat-raised-button color="danger">
                    Delete
                  </button></td>
              </tr>

            </tbody>
            <tfoot>
              <tr>
                <td colspan="13"></td>
                <td>{{ this.receiptledgertotalamt }}</td>
                <!-- <td>{{ this.receiptledgerdiscounttotal }}</td> -->
              </tr>
            </tfoot>
          </table>
        </div>

        <div>
          <button mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger new-btn-danger"
            style="float: none; margin-left: 40%; margin-top: 2%;"
            (click)="exportExcel3('Subscriber Receipt Ledger')">Export</button>

          <button class="noPrint" style="margin-top: -5%; margin-left: 50%" mat-raised-button color="primary"
            (click)="printPage3()">
            Print
          </button>

        </div>

      </mat-card>
    </mat-tab>

    <mat-tab label="GST Report">
      <mat-card>
        <div class="form-row">
          <mat-form-field appearance="fill" style="margin-top: 1%">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [formGroup]="gstreportForm" [rangePicker]="pickergst" [min]="financialYearMin"
              [max]="financialYearMax">
              <input matStartDate formControlName="start" placeholder="Start date" />
              <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getChangedDategstreport()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickergst"></mat-datepicker-toggle>
            <mat-date-range-picker #pickergst></mat-date-range-picker>

            <mat-error *ngIf="
                          gstreportForm.controls.start.hasError('matStartDateInvalid')
                        ">Invalid start date
            </mat-error>
            <mat-error *ngIf="gstreportForm.controls.end.hasError('matEndDateInvalid')">Invalid end date
            </mat-error>
          </mat-form-field>
          <div style="margin-left: 5%;margin-top: 2%;">
            <button class="btn" mat-raised-button color="primary" (click)="GSTReportPrint()">GST
              Report Print</button>
          </div>
        </div>
        <div id="excel-table">
          <div class="tableFixHead">
            <button type="button" (click)="excelToExportGSTReport('GST_Report')" class="btn btn-danger">
              Export
            </button>
            <!-- <cdk-virtual-scroll-viewport appendOnly itemSize="50" class="example-viewport"> -->
            <table class="table table-striped text-center">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Receipt Date</th>
                  <th>Customer Name</th>
                  <th>Address of Company</th>
                  <th>Receipt No</th>
                  <th>GST No</th>
                  <th>HSN Code</th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of showGSTReceiptData; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item["crdt_voucher_date"] | date:"dd-MM-yyyy" }}</td>
                  <td>{{ item["e_name"] }}</td>
                  <td>{{ item["e_district"] }}</td>
                  <td><input type="text" value="{{ item['rcpt_no'] }}"
                      (change)="addBillGSTHSNData($event, i, 'billno')"></td>
                  <td><input type="text" value="{{ item['gst_no'] }}" (change)="addBillGSTHSNData($event, i, 'gstno')">
                  </td>
                  <td><input type="text" value="{{ item['hsn_code'] }}"
                      (change)="addBillGSTHSNData($event, i, 'hsncode')"></td>
                  <td>{{ item["total_amt"] }}</td>
                </tr>
                <tr>
                  <td colspan="7"></td>
                  <td>{{ this.gstreporttotalamt }}</td>
                </tr>
              </tbody>
            </table>
            <!-- </cdk-virtual-scroll-viewport> -->
          </div>
        </div>
      </mat-card>
    </mat-tab>

    <mat-tab label="Posting Label & Statement">
      <form [formGroup]="generateform">
        <div class="form-row">
          <mat-form-field style="margin-left: 7%; margin-top: 20px; width: 25%" appearance="outline">
            <mat-label>Issue/Grantha Category : </mat-label>
            <mat-select>
              <mat-option *ngFor="let item of advtCategorylist" value="{{ item['category'] }}">
                {{ item["category"] }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" style="margin-left: 3%; width: 25%; margin-top: 20px">
            <mat-label>Select issue date</mat-label>
            <input matInput [matDatepickerFilter]="myFilter" formControlName="issue_date" [matDatepicker]="pickerissue"
              (dateChange)="getIssueDate($event)">
            <mat-datepicker-toggle matSuffix [for]="pickerissue"></mat-datepicker-toggle>
            <mat-datepicker #pickerissue></mat-datepicker>
          </mat-form-field>

          <mat-form-field style="margin-left: 3%; margin-top: 20px; width: 25%" appearance="outline">
            <mat-label>Select Published date</mat-label>
            <input matInput required formControlName="publisheddate" [matDatepicker]="pickerpubdate" />
            <mat-datepicker-toggle matSuffix [for]="pickerpubdate"></mat-datepicker-toggle>
            <mat-datepicker #pickerpubdate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" style="margin-left: 7%; width: 25%">
            <mat-label>Enter a date from...to </mat-label>
            <mat-date-range-input [rangePicker]="pickerbrr">
              <input matStartDate formControlName="start" placeholder="Start date" />
              <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getBookReceiptDateRange()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerbrr"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerbrr></mat-date-range-picker>

            <mat-error *ngIf="
                generateform.controls.start.hasError('matStartDateInvalid')
              ">Invalid start date</mat-error>
            <mat-error *ngIf="generateform.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Title</mat-label>
            <mat-select #mySel11 formControlName="title" (selectionChange)="get_titles($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelection11()">All</mat-option>
              <mat-option *ngFor="let option of LabelsDispatchTitles" [value]="option['title']">{{
                option["title"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="title1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_titles()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Subscriber Name</mat-label>
            <mat-select #mySel1 formControlName="subname" (selectionChange)="getsubnames($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelection1()">All</mat-option>
              <mat-option *ngFor="let option of LabelsDispatchSubnames" [value]="option['sub_name']">{{
                option["sub_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="sub_names" matSuffix mat-icon-button aria-label="Clear" (click)="reset_sub_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%">
            <mat-label>Subscriber Type</mat-label>
            <mat-select #mySel2 formControlName="subtype" (selectionChange)="getsubtypes($event)" multiple>
              <mat-option *ngFor="let option of LabelsDispatchSubtypes" [value]="option['sub_type']">{{
                option["sub_type"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="sub_types" matSuffix mat-icon-button aria-label="Clear" (click)="reset_sub_types()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Country Name</mat-label>
            <mat-select #mySel3 formControlName="countryname"
              (selectionChange)="getCountry($event); getcountryname($event)" multiple>
              <mat-option *ngFor="let option of countries" [value]="option['country_name']">{{
                option["country_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="country_names" matSuffix mat-icon-button aria-label="Clear" (click)="reset_country_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>State Name</mat-label>
            <mat-select #mySelState formControlName="statename" (selectionChange)="getstatename($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelectionState()">All</mat-option>
              <mat-option *ngFor="let option of states" [value]="option['state_name']">{{
                option["state_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="state_names" matSuffix mat-icon-button aria-label="Clear" (click)="reset_state_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="form-row">
          <!-- <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%">
            <mat-label>District Name</mat-label>
            <mat-option value="all" (click)="toggleAllSelection5()">All</mat-option>
            <mat-select #mySel5 formControlName="districtname"
              (selectionChange)="getDistricts($event); getdistrictname($event)" multiple>
              <mat-option *ngFor="let option of cities" [value]="option['district_name']">{{
                option["district_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="district_names" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_district_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field> -->




          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%">
            <mat-label>District Name</mat-label>
            <mat-select #mySel5 formControlName="districtname"
              (selectionChange)="getDistricts($event); getdistrictname($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelection5()">All</mat-option>
              <mat-option *ngFor="let option of cities" [value]="option['district_name']">{{
                option["district_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="district_names" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_district_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>


          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Taluka Name</mat-label>
            <mat-select #mySel6 formControlName="talukaname" (selectionChange)="gettalukaname($event)" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection6()">All</mat-option>
              <mat-option *ngFor="let option of talukas" [value]="option['taluka_name']">{{
                option["taluka_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="taluka_names" matSuffix mat-icon-button aria-label="Clear" (click)="reset_taluka_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Pincode</mat-label>
            <mat-select #mySel7 formControlName="pincode" (selectionChange)="getpincode($event)" multiple>
              <mat-option *ngFor="let option of pindcodelist" [value]="option['pincode']">{{
                option["pincode"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="pincodes" matSuffix mat-icon-button aria-label="Clear" (click)="reset_pincodes()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%">
            <mat-label>Representative</mat-label>
            <mat-select #mySel8 formControlName="rep" (selectionChange)="getrep($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelection8()">All</mat-option>
              <mat-option *ngFor="let option of LabelsDispatchRepNames" [value]="option['rep_name']">{{
                option["rep_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="repnames" matSuffix mat-icon-button aria-label="Clear" (click)="reset_repnames()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Office Representative</mat-label>
            <mat-select #mySel9 formControlName="officerep" (selectionChange)="getofficerep($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelection9()">All</mat-option>
              <mat-option *ngFor="let option of LabelsDispatchOffRepNames" [value]="option['off_rep_name']">{{
                option["off_rep_name"]
                }}</mat-option>
            </mat-select>
            </mat-form-field>

          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Distribution Representative</mat-label>
            <mat-select #mySel12 formControlName="disrep" (selectionChange)="getdistributionrep($event)" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let option of LabelsDispatchDisRepNames" [value]="option['dis_rep_name']">{{
                option["dis_rep_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="disrepnames" matSuffix mat-icon-button aria-label="Clear" (click)="reset_distribution_rep_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

            <button *ngIf="officerepnames" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_office_rep_names()">
              <mat-icon>close</mat-icon>
            </button>
          
           <!-- <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Delivery Mode</mat-label>
            <mat-select #mySel10 formControlName="delivery_mode_name" (selectionChange)="getmode_name($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelection10()">All</mat-option>
              <mat-option *ngFor="let option of LabelsDispatchDeliveryModes" [value]="option['mode_name']">{{
                option["mode_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="mode_names" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_delivery_mode_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field> -->
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%">
            <mat-label>Show Mobile No. in Labels</mat-label>
            <mat-select (selectionChange)="getmob_no($event)">
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Show Customer No</mat-label>
            <mat-select (selectionChange)="getIsCustomer($event)">
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
          </mat-form-field>

           <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Delivery Mode</mat-label>
            <mat-select #mySel10 formControlName="delivery_mode_name" (selectionChange)="getmode_name($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelection10()">All</mat-option>
              <mat-option *ngFor="let option of LabelsDispatchDeliveryModes" [value]="option['mode_name']">{{
                option["mode_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="mode_names" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_delivery_mode_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <div style="margin-left: 3%">
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%">
            <mat-label>IDs Show</mat-label>
            <mat-select (selectionChange)="getIDs($event)">
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
          </mat-form-field>

            <button *ngIf="!show_mob_no_hide" mat-raised-button color="primary"
              style="margin-left: 3%;padding-top: 31px;padding-bottom: 21px;" (click)="getAddressLabels()">Districtwise
              Posting Address Label</button>
            <button *ngIf="show_mob_no_hide" mat-raised-button color="primary" style="margin-left: 3%;margin-top: 2%;"
              (click)="getAddressLabelswithMobileNo()">
              Districtwise Posting Address Label
            </button>
          </div>
          <div style="display: flex; align-items: center; gap: 1rem; margin-left: 7%;">
            <button *ngIf="!show_mob_no_hide" mat-raised-button matTooltip="search"
              class="btn btn-danger new-btn-danger" (click)="postingLabelBriefReport()">
              Excel
            </button>

            <button *ngIf="show_mob_no_hide" mat-raised-button matTooltip="search" class="btn btn-danger new-btn-danger"
              (click)="getPostingLabelswithMobileNoReport()">
              Brief
            </button>

            <button mat-raised-button color="primary" (click)="openBarcodeDialog('ADD')">
              Go to Generate Barcodes
            </button>
            <button mat-raised-button color="primary" (click)="openBarcodeDialog('UPDATE')">
              Barcodes View
            </button>
          </div>

        </div>
      </form>

      <mat-card>
        <div style="text-align: center;
    font-size: 2rem;
    font-weight: 500;">Post Statement</div>
        <div class="form-row">
          <mat-form-field appearance="outline" style="margin-left: 3%; width: 25%; margin-top: 20px">
            <mat-label>Select Dispatch Date</mat-label>
            <input matInput [matDatepicker]="pickerdispatch" (dateChange)="getDispatchDate($event)">
            <mat-datepicker-toggle matSuffix [for]="pickerdispatch"></mat-datepicker-toggle>
            <mat-datepicker #pickerdispatch></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="form-row">
          <button mat-raised-button color="primary" style="margin-left: 1%;margin-top: 2%;"
            (click)="getDistrictwiseStatement(true)">Districtwise Statement</button>
          <button mat-raised-button color="danger" class="btn btn-danger new-btn-danger"
            style="margin-left: 2%;margin-top: 2%;" (click)="getDistrictwiseStatement(false)">view</button>
          <button mat-raised-button color="primary" style="margin-left: 3%;margin-top: 2%;"
            (click)="getStatewiseStatement(true)">Statewise Statement</button>
          <button mat-raised-button color="danger" class="btn btn-danger new-btn-danger"
            style="margin-left: 2%;margin-top: 2%;" (click)="getStatewiseStatement(false)">view</button>
          <button mat-raised-button color="primary" style="margin-left: 2%;margin-top: 2%;"
            (click)="getPincodewiseStatement(true)">Pincodewise Statement</button>
          <button mat-raised-button color="danger" class="btn btn-danger new-btn-danger"
            style="margin-left: 2%;margin-top: 2%;" (click)="getPincodewiseStatement(false)">view</button>
          <button mat-raised-button color="primary" style="margin-left: 2%;margin-top: 2%;"
            (click)="getOtherStatePincodewiseStatement(true)">Other State Pincodewise Statement</button>
          <button mat-raised-button color="danger" class="btn btn-danger new-btn-danger"
            style="margin-left: 2%;margin-top: 2%;" (click)="getOtherStatePincodewiseStatement(false)">view</button>
        </div>

      </mat-card>

      <!-- <mat-card>
        <mat-form-field appearance="outline" style="margin-left: 3%; width: 25%; margin-top: 20px">
          <mat-label>Select Dispatch Date</mat-label>
          <input matInput [matDatepicker]="pickerdispatch1" (dateChange)="getDispatchDate($event)">
          <mat-datepicker-toggle matSuffix [for]="pickerdispatch1"></mat-datepicker-toggle>
          <mat-datepicker #pickerdispatch1></mat-datepicker>
        </mat-form-field>
        <button mat-raised-button color="primary" style="margin-left: 2%;margin-top: 2%;"
          (click)="getDistrictwiseStatement()">Districtwise Statement</button>
      </mat-card> -->

      <mat-card>
        <div style="text-align: center;
            font-size: 2rem;
            font-weight: 500;margin-bottom: 1rem;margin-top: 25px;">Hand Delivery Statement</div>
        <!-- <div class="form-row"> -->
        <form [formGroup]="distributionForm">
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 1%">
              <mat-label>Distribution Representative</mat-label>
              <mat-select #mySel12 formControlName="disrep" (selectionChange)="getdistributionrep($event)" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let option of LabelsDispatchDisRepNames" [value]="option['dis_rep_name']">{{
                  option["dis_rep_name"]
                  }}</mat-option>
              </mat-select>
              <button *ngIf="disrepnames" matSuffix mat-icon-button aria-label="Clear"
                (click)="reset_distribution_rep_names()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
              <mat-label>Distribution Mode</mat-label>
              <mat-select #mySel13 formControlName="dismode" (selectionChange)="getdismode($event)">
                <mat-option *ngFor="let option of newdismode" [value]="option['dis_mode']">{{
                  option["dis_mode"]
                  }}</mat-option>
              </mat-select>
              <button *ngIf="dismode1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_dismode()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
              <mat-label>Sub Distribution Mode</mat-label>
              <mat-select #mySel14 formControlName="subdismode" (selectionChange)="getsubdismode($event)">
                <mat-option *ngFor="let option of subdistmode" [value]="option['dis_sub_mode']">{{
                  option["dis_sub_mode"]
                  }}</mat-option>
              </mat-select>
              <button *ngIf="subdismode" matSuffix mat-icon-button aria-label="Clear" (click)="reset_subdismode()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <!-- <div class="form-row">
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
              <mat-label>Distribution Mode</mat-label>
              <mat-select #mySel13 formControlName="subdismode" (selectionChange)="getdismode($event)">
                <mat-option *ngFor="let option of LabelsDisModes" [value]="option['dis_mode']">{{
                  option["dis_mode"]
                  }}</mat-option>
              </mat-select>
              <button *ngIf="dismode1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_dismode()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
              <mat-label>Sub Distribution Mode</mat-label>
              <mat-select #mySel13 formControlName="subdismode" (selectionChange)="getsubdismode($event)">
                <mat-option *ngFor="let option of FilteredLabelsSubDisModes" [value]="option['sub_dis_mode']">{{
                  option["sub_dis_mode"]
                  }}</mat-option>
              </mat-select>
              <button *ngIf="subdismode" matSuffix mat-icon-button aria-label="Clear" (click)="reset_subdismode()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div> -->
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 1%">
              <mat-label>एका प्रतीचे वजन</mat-label>
              <input matInput type="number" formControlName="vajan">
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
              <mat-label>टपाल दर</mat-label>
              <input matInput type="number" formControlName="tapalrate">
            </mat-form-field>
          </div>
        </form>
        <div class="form-row">
          <button mat-raised-button color="primary" style="margin-left: 1%;margin-bottom: 5%;"
            (click)="handDeliveryLabelList()">Dispatch
            Address</button>

          <button mat-raised-button color="primary" style="margin-left: 2%;margin-bottom: 5%;"
            (click)="handDeliveryLabel(true)">Parcel
            Label</button>
          <button mat-raised-button color="danger" class="btn btn-danger new-btn-danger"
            style="margin-left: 1%; margin-bottom: 5%;" (click)="handDeliveryLabel(false)">view</button>

          <button mat-raised-button color="primary" (click)="openBarcodeDialogForParcel(true)"
            style="margin-left: 0%; margin-bottom: 5%;">
            Go to Generate Barcodes Parcel
          </button>
          <button mat-raised-button color="primary" (click)="openBarcodeDialogForParcel(false)"
            style="margin-left: 1%; margin-bottom: 5%;">
            Parcel Barcodes View
          </button>

          <button mat-raised-button color="primary" style="margin-bottom: 5%;" (click)="postStatement(true)">Dispatch
            Statement</button>
          <button mat-raised-button color="danger" class="btn btn-danger new-btn-danger"
            style="margin-left: 1%;margin-bottom: 5%;" (click)="postStatement(false)">view</button>

          <button mat-raised-button color="primary" style="margin-bottom: 5%;" (click)="handDelivery(true)">All
            Distributor Copies</button>
          <button mat-raised-button color="danger" class="btn btn-danger new-btn-danger"
            style="margin-left: 1%;margin-bottom: 5%;" (click)="handDelivery(false)">view</button>
        </div>
        <div class="form-row">

        </div>
        <!-- </div> -->
      </mat-card>



      <div class="form-row" style="
    display: flex;
    align-items: center;
    justify-content: center; /* Centers the heading text */
    position: relative;
    background-color: #8bbdbd;
    margin-bottom: 2%;
    margin-top: 2%;
    padding: 10px 20px;
    text-align: center;
    width: 100%;
" (click)="toggleFields()">

        <h2 style="color: black; margin: 0;padding: 5px;">
          Print Order
        </h2>

        <!-- Font Awesome Arrow Icon -->


        <i class="fas fa-arrow-down" *ngIf="!showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;"></i>

        <i class="fas fa-arrow-up" *ngIf="showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;"></i>

      </div>

      <ng-container *ngIf="showFields" style="margin-left: 2%">
        <mat-card>
          <button mat-raised-button color="primary" style="margin-left: 2%;width: 150px;" (click)="printOrder()">Print
            Order</button>

          <div class="tableFixHead" style="margin-top: 2%;">
            <table class="table table-bordered ">
              <thead>
                <tr>
                  <th>आदेश क्र</th>
                  <th>आदेश दिनांक</th>
                  <th>अंक दिनांक...ते</th>
                  <th>एकूण प्रती</th>
                  <th>एकूण पृष्ठ</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of printOrderData; let i = index">
                  <td style="text-align: center;">{{ item['weeksCount'] }}</td>
                  <td style="text-align: center;">{{ item['order_date'] }}</td>
                  <td style="text-align: center;">{{ item['issue_date_from'] | date:"dd-MM-yyyy" }} ते {{
                    item['issue_date_to'] | date:"dd-MM-yyyy"
                    }}
                  </td>
                  <td style="text-align: center;">{{ item['total_prati'] }}</td>
                  <td style="text-align: center;">{{ item['total_prustha'] }}</td>
                  <td><button mat-icon-button type="button" class="btn-sm btn-outline-primary" matTooltip="View"
                      (click)="viewPrintOrder(item)"><mat-icon>visibility</mat-icon></button>
                    <button mat-icon-button type="button" class="btn-sm btn-outline-info" matTooltip="Update"
                      (click)="updatePrintOrder(item)"><mat-icon>edit</mat-icon></button>
                    <!-- <button mat-icon-button class="btn-sm btn-outline-danger" matTooltip="Delete"
                      style="margin-left: 2%;"
                      (click)="cancelPrintOrder(item['order_id'])"><mat-icon>delete</mat-icon></button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-card>

        <mat-card>
          <button mat-raised-button color="primary" style="margin-left: 2%;width:100px"
            (click)="printJavak()">जावक</button>

          <!-- <button mat-raised-button color="primary" style="margin-left: 2%;width:100px" (click)="printchallan()">challan</button> -->

        </mat-card>

        <mat-card>
          <div class="row">
            <div class="col-md-3 col-12">
              <button mat-raised-button color="primary" style="margin-left: 2%; width:220px; height: 50px;"
                (click)="distSubReport()">Districtwise
                Subscription Report</button>
            </div>
            <div class="col-md-3 col-12">
              <button mat-raised-button color="primary" style="width:220px; height: 50px;"
                (click)="distVSubReport()">Districtwise
                Varganidar
                Subscription Report</button>
            </div>
            <div class="col-md-3 col-12">
              <button mat-raised-button color="primary" style="width:200px; height: 50px;"
                (click)="prantwiseReport()">Prantwise
                Report</button>
            </div>
            <div class="col-md-3 col-12">
              <button mat-raised-button color="primary" style="margin-left: -20px; width:240px; height: 50px;"
                (click)="RepresentativewiseSadhyasthitiReport()">Representativewise Sadhyasthiti Report
              </button>
            </div>

          </div>

          <div class="row">
            <div class="col-md-3 col-12" style="padding-top: 30px;">
              <button mat-raised-button color="primary" style="margin-left: 2%; width:220px; height: 65px;"
                (click)="DistrictRepresentativewiseSadhyasthitiReport()">District Representativewise Sadhyasthiti Report
              </button>
            </div>

            <div class="col-md-3 col-12" style="padding-top: 30px;">
              <button mat-raised-button color="primary" style="width:220px; height: 65px;"
                (click)="TalukaRepresentativewiseSadhyasthitiReport()">Taluka Representativewise Sadhyasthiti Report
              </button>
            </div>


          </div>

        </mat-card>
      </ng-container>




    </mat-tab>

    <!-- <mat-tab label="Print Order">

      <mat-card>
        <button mat-raised-button color="primary" style="margin-left: 2%;width: 150px;" (click)="printOrder()">Print
          Order</button>

        <div class="tableFixHead" style="margin-top: 2%;">
          <table class="table table-bordered ">
            <thead>
              <tr>
                <th>आदेश क्र</th>
                <th>आदेश दिनांक</th>
                <th>अंक दिनांक...ते</th>
                <th>एकूण प्रती</th>
                <th>एकूण पृष्ठ</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of printOrderData">
                <td>{{ item['order_id'] }}</td>
                <td>{{ item['order_date'] }}</td>
                <td>{{ item['issue_date_from'] | date:"dd-MM-yyyy" }} ते {{ item['issue_date_to'] | date:"dd-MM-yyyy" }}
                </td>
                <td>{{ item['total_prati'] }}</td>
                <td>{{ item['total_prustha'] }}</td>
                <td><button mat-icon-button type="button" class="btn-sm btn-outline-primary" matTooltip="View"
                    (click)="viewPrintOrder(item)"><mat-icon>visibility</mat-icon></button>
                  <button mat-icon-button type="button" class="btn-sm btn-outline-info" matTooltip="Update"
                    (click)="updatePrintOrder(item)"><mat-icon>edit</mat-icon></button>
                  <button mat-icon-button class="btn-sm btn-outline-danger" matTooltip="Delete" style="margin-left: 2%;"
                    (click)="cancelPrintOrder(item['order_id'])"><mat-icon>delete</mat-icon></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>

      <mat-card>
        <button mat-raised-button color="primary" style="margin-left: 2%;width:100px"
          (click)="printJavak()">जावक</button>


      </mat-card>

      <mat-card>
        <div class="row">
          <div class="col-md-4 col-12">
            <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
              (click)="distSubReport()">Districtwise
              Subscription Report</button>
          </div>
          <div class="col-md-4 col-12">
            <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
              (click)="distVSubReport()">Districtwise
              Varganidar
              Subscription Report</button>
          </div>
          <div class="col-md-4 col-12">
            <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
              (click)="prantwiseReport()">Prantwise
              Report</button>
          </div>
        </div>
      </mat-card>
    </mat-tab> -->

    <mat-tab label="Subscription Business Report">
      <mat-card>
        <form [formGroup]="daterepForm">
          <div class="form-row">
            <mat-form-field appearance="fill" style="margin-top: 1%; width: 30%;">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [rangePicker]="pickerdaterep" [min]="financialYearMin" [max]="financialYearMax">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getChangedDaterep()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerdaterep"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerdaterep></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field appearance="fill" style="margin-left: 3%; margin-top: 1%; width: 30%;">
              <mat-label>Representative Name</mat-label>
              <mat-select formControlName="rep_name" (selectionChange)="getrepnames($event)" multiple>

                <mat-option *ngFor="let option of filtereddaterepwiserep_name" [value]="option['rep_name']">{{
                  option["rep_name"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field appearance="fill" class="example-full-width"
              style="margin-left: 3%; margin-top: 1%; width: 30%;">
              <mat-label>Office Representative Name</mat-label>
              <input matInput formControlName="off_rep_name" [matAutocomplete]="autooff_rep_name" />
              <button *ngIf="off_rep_name1 != 'lmn'" matSuffix mat-icon-button aria-label="Clear"
                (click)="reset_off_rep_name()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete autoActiveFirstOption #autooff_rep_name="matAutocomplete" multiple>
                <mat-option (onSelectionChange)="getoff_rep_name($event, option)"
                  *ngFor="let option of filteredOptions22 | async" [value]="option['office_rep_name']">
                  {{ option["office_rep_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->


            <mat-form-field appearance="fill" style="margin-left: 3%; margin-top: 1%; width: 30%;">
              <mat-label>Office Representative Name</mat-label>
              <mat-select formControlName="off_rep_name" (selectionChange)="getOffice_Rep($event)" multiple>
                <!-- <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option *ngFor="let option of LabelsDispatchOffRepNames" [value]="option['off_rep_name']">{{
                  option["off_rep_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="form-row">
            <mat-form-field style="margin-top: 1%;  width: 30%;" appearance="fill">
              <mat-label>Country</mat-label>
              <mat-select (selectionChange)="getCountry($event)" formControlName="country" multiple>
                <mat-option *ngFor="let c of countries" value="{{ c['country_name'] }}">{{ c["country_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <!-- 
            <mat-form-field style="margin-left: 3%; margin-top: 1%; width: 30%;" appearance="fill">
  <mat-label>State</mat-label>
  <mat-select (selectionChange)="getState($event)" formControlName="state" multiple>
    <mat-option *ngFor="let c of states" [value]="c.state_name">{{ c.state_name }}</mat-option>
  </mat-select>
  <span>{{ selectedState }}</span>
</mat-form-field> -->

            <mat-form-field appearance="fill" style="margin-left: 3%; margin-top: 1%; width: 30%;">
              <mat-label>State Name</mat-label>
              <mat-select #mySel4 formControlName="state" (selectionChange)="getstatename($event)" multiple>

                <mat-option *ngFor="let c of states" [value]="c.state_name">{{
                  c["state_name"]
                  }}</mat-option>
              </mat-select>
              <!-- <button *ngIf="state_names" matSuffix mat-icon-button aria-label="Clear" (click)="reset_state_names()">
    <mat-icon>close</mat-icon>
  </button> -->
            </mat-form-field>

            <!-- <mat-form-field appearance="fill" class="example-full-width" style=" margin-top: 1%; width: 30%; margin-left: 3%;">
              <mat-label>District</mat-label>
              <input matInput formControlName="district" (keyup)="searchDistrict($event)"
                [matAutocomplete]="auto_district" />
              <mat-autocomplete autoActiveFirstOption #auto_district="matAutocomplete">
                <mat-option (onSelectionChange)="selectDistrict($event, option)"
                  *ngFor="let option of filteredDistrictName" [value]="option['district_name']">
                  {{ option["district_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->
            <mat-form-field style="margin-left: 3%; margin-top: 1%; width: 30%;" appearance="fill">
              <mat-label>District</mat-label>
              <mat-select (selectionChange)="getDistricts($event)" formControlName="district" multiple>
                <mat-option *ngFor="let c of cities" value="{{ c['district_name'] }}">{{ c["district_name"] }}
                </mat-option>
              </mat-select>
              <span>{{ selectedCity }}</span>
            </mat-form-field>

            <mat-form-field appearance="fill" style="margin-top: 1%; width: 30%;">
              <mat-label>Taluka </mat-label>
              <mat-select #mySel6 formControlName="tal_name" (selectionChange)="gettalukaname($event)" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection6()">All</mat-option>
                <!-- LabelsDispatchTalukaName -->
                <mat-option *ngFor="let c of talukas" [value]="c['taluka_name']">{{
                  c["taluka_name"]
                  }}</mat-option>
              </mat-select>
              <!-- <button *ngIf="taluka_names" matSuffix mat-icon-button aria-label="Clear" (click)="reset_taluka_names()">
                    <mat-icon>close</mat-icon>
                  </button> -->
            </mat-form-field>

            <!-- <mat-form-field style=" margin-top: 1%; width: 30%;" appearance="fill">
              <mat-label>Taluka</mat-label>
              <mat-select formControlName="tal_name" multiple>
                <mat-option *ngFor="let c of talukas" value="{{ c['taluka_name'] }}">{{ c["taluka_name"] }}</mat-option>
              </mat-select>
              <span>{{ selectedTaluka }}</span>
            </mat-form-field> -->

            <mat-form-field appearance="fill" style="margin-left: 3%; width: 30%; margin-top: 1%;"
              class="example-full-width">
              <mat-label>Prant Name</mat-label>
              <mat-select formControlName="prant_name" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let option of prantdata" [value]="option['prant_name']">{{ option["prant_name"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field appearance="fill" class="example-full-width"
              style="margin-left: 3%; width: 30%; margin-top: 1%;">
              <mat-label>Prant Name</mat-label>
              <input matInput formControlName="prant_name" [matAutocomplete]="prantname" />
              <button *ngIf="sub_names1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_sub_names1()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete autoActiveFirstOption #prantname="matAutocomplete">
                <mat-option *ngFor="let option of prantdata" [value]="option['prant_name']">
                  {{ option["prant_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->

            <!-- <mat-form-field class="example-full-width" appearance="fill"
              style="width: 30%; margin-left: 3%; margin-top: 1%;">
              <mat-label>Subscription Type</mat-label>
              <input matInput formControlName="duration" [matAutocomplete]="autodua" />
              <mat-autocomplete autoActiveFirstOption #autodua="matAutocomplete">
                <mat-option (onSelectionChange)="durationn($event, option)" *ngFor="let option of subscriptiontype "
                  [value]="option['subtype']">
                  {{ option["subtype"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->


            <mat-form-field appearance="fill" style="margin-left: 3%; margin-top: 1%; width: 30%;">
              <mat-label>Subscription Type</mat-label>
              <mat-select formControlName="duration" multiple>
                <mat-option *ngFor="let option of subscriptiontype" [value]="option['subtype']">
                  {{ option['subtype'] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field appearance="fill" style=" margin-top: 1%; width: 30%;">
              <mat-label>New/Renew</mat-label>
              <mat-select formControlName="rcpt_type" (selectionChange)="getReceiptType($event)">
                <mat-option value="New">New</mat-option>
                <mat-option value="Renew">Renew</mat-option>
              </mat-select>
            </mat-form-field> -->

            <mat-form-field appearance="fill" style="margin-top: 1%; width: 30%;">
              <mat-label>New/Renew</mat-label>
              <mat-select formControlName="rcpt_type" multiple>
                <mat-option value="New">New</mat-option>
                <mat-option value="Renew">Renew</mat-option>
              </mat-select>
            </mat-form-field>


            <mat-form-field appearance="outline" style="margin-top: 1%; width: 30%; margin-left: 3%; background-color: #1976d2;
               border-radius: 6px; color: #fff; height: 56px;">
              <mat-label style="color: #fff;">Datewise/Varganidar Report</mat-label>
              <mat-select formControlName="reportType" (selectionChange)="getReportChange($event)"
                style="color: #fff; font-weight: 500;" panelClass="custom-select-panel">

                <mat-option (click)="DateRepwise()"> Datewise/Varganidar </mat-option>

                <!-- <mat-option (click)="datewiseRepIndetails()">Datewise/Representativewise Indetails</mat-option> -->

                <mat-option (click)="Datewise()">Datewise</mat-option>

                <mat-option (click)="DatewiseBriefly()">Datewise Briefly</mat-option>

                <mat-option (click)="Monthwise()"> Monthwise</mat-option>

                <!-- <mat-option (click)="offrepwise()"> Office Representativewise </mat-option> -->

                <!-- <mat-option (click)="repwise()"> Representativewise</mat-option> -->

                <mat-option (click)="countrywise()"> Countrywise</mat-option>

                <!-- <mat-option (click)="prantwise()"> Pranttwise</mat-option> -->

                <mat-option (click)="statewise()"> Statewise</mat-option>

                <!-- <mat-option (click)="districtwise()"> Districtwise</mat-option> -->

                <!-- <mat-option (click)="districtandtalukawise()"> Talukawise</mat-option> -->

                <mat-option (click)="typewiseawise()"> Typewise</mat-option>

                <mat-option (click)="DateRepwise1()"> New/Renew</mat-option>

              </mat-select>
            </mat-form-field>

            <!-- District Wise Report -->
            <!-- <mat-form-field appearance="fill" style=" margin-top: 1%; width: 30%; margin-left: 3%;">
              <mat-label>District Wise Report</mat-label>
              <mat-select formControlName="districtWiseReport" (selectionChange)="getReportChange($event)">

                  <mat-option (click)="districtwise()"> Districtwise</mat-option>

                  <mat-option (click)="districtwiseRepresentative()"> Districtwise Representative</mat-option>

              </mat-select>
            </mat-form-field> -->

            <mat-form-field appearance="outline" style="margin-top: 1%; width: 30%; margin-left: 3%; background-color: #1976d2;
                      border-radius: 6px; color: #fff; height: 56px;">
              <mat-label style="color: #fff;">District Wise Report</mat-label>
              <mat-select formControlName="districtWiseReport" (selectionChange)="getReportChange($event)"
                style="color: #fff; font-weight: 500;" panelClass="custom-select-panel">
                <mat-option (click)="districtwise()">Districtwise</mat-option>
                <mat-option (click)="districtwiseRepresentative()">Districtwise Representative</mat-option>
                <mat-option (click)="districtwiseOfficeRepresentative()">Districtwise Office-Representative</mat-option>
              </mat-select>
            </mat-form-field>



            <!-- Representative Wise Report -->
            <mat-form-field appearance="outline" style="margin-top: 1%; width: 30%; background-color: #1976d2;
                      border-radius: 6px; color: #fff; height: 56px;">
              <mat-label style="color: #fff;">Representativewise Report</mat-label>
              <mat-select style="color: #fff; font-weight: 500;" formControlName="representativWiseReport"
                (selectionChange)="getReportChange($event)">

                <mat-option (click)="repwise()"> Representativewise</mat-option>
                <mat-option (click)="repwiseDistrict()"> Representativewise District</mat-option>
                <mat-option (click)="repwiseTaluka()"> Representativewise Taluka</mat-option>

              </mat-select>
            </mat-form-field>

            <!-- Office Representative Wise Report -->
            <mat-form-field appearance="outline" style="margin-top: 1%; width: 30%; margin-left: 3%; background-color: #1976d2;
                      border-radius: 6px; color: #fff; height: 56px;">
              <mat-label style="color: #fff;">Office Representativewise Report</mat-label>
              <mat-select style="color: #fff; font-weight: 500;" formControlName="officeRepresentativWiseReport"
                (selectionChange)="getReportChange($event)">

                <mat-option (click)="offrepwise()"> Office Representativewise </mat-option>
                <!-- <mat-option (click)=" offrepdistrict()"> Office Representatively Briefly</mat-option>  -->
                <!-- <mat-option (click)="offrepdistrictwise()"> Office RepresentativeDistrictWise </mat-option> -->
                <!-- <mat-option (click)=" offrepdistrict()"> office representativeDistrict </mat-option> -->

              </mat-select>
            </mat-form-field>

            <!-- Taluka Wise Report -->
            <!-- <mat-form-field appearance="outline" style="margin-top: 1%; width: 30%; margin-left: 3%; background-color: #1976d2;
                      border-radius: 6px; color: #fff; height: 56px;">
              <mat-label style="color: #fff;">Talukawise Report</mat-label>
              <mat-select style="color: #fff; font-weight: 500;" formControlName="talukaWiseReport"
                (selectionChange)="getReportChange($event)">

                <mat-option (click)="districtandtalukawise()"> Talukawise</mat-option>

              </mat-select>
            </mat-form-field> -->

            <mat-form-field appearance="outline" style="margin-top: 1%; width: 30%; margin-left: 3%; background-color: #1976d2;
                               border-radius: 6px; color: #fff; height: 56px;">

              <mat-label style="color: #fff;">Talukawise Report</mat-label>

              <mat-select formControlName="talukaWiseReport" (selectionChange)="getReportChange($event)"
                style="color: #fff; font-weight: 500;" panelClass="custom-select-panel">

                <mat-option (click)="districtandtalukawise()">Talukawise</mat-option>
                <mat-option (click)="districtandtalukawiseRepresentative()">Talukawise Representative</mat-option>
                <mat-option (click)="districtandtalukawiseOfficeRepresentative()">Talukawise
                  Office-Representative</mat-option>


              </mat-select>
            </mat-form-field>

            <!-- Prantwise Report -->
            <mat-form-field appearance="outline" style="margin-top: 2%; width: 30%; background-color: #1976d2;
                      border-radius: 6px; color: #fff; height: 56px;">
              <mat-label style="color: #fff;">Pranttwise Report</mat-label>
              <mat-select style="color: #fff; font-weight: 500;" formControlName="prantWiseReport"
                (selectionChange)="getReportChange($event)">

                <mat-option (click)="prantwise()"> Pranttwise</mat-option>

              </mat-select>
            </mat-form-field>


            <!-- All Bussiness Report -->
            <mat-form-field appearance="outline" style="margin-top: 2%; width: 30%; margin-left: 3%; background-color: #ee0e0e;
                      border-radius: 6px; color: #fff; height: 56px;">
              <mat-label style="color: #fff;">All Business Report</mat-label>
              <mat-select style="color: #fff; font-weight: 500;" formControlName="allBusinessReport"
                (selectionChange)="getReportChange($event)">

                <mat-option (click)="allBusinessReport()"> All Business Report</mat-option>
                <mat-option (click)="monthWiseBusinessReport()">Monthwise Report</mat-option>
                <mat-option (click)="allTotalBusinessReport()"> All Total Business Report</mat-option>
                <mat-option (click)="prantwiseAllTotalDistrictBusinessReport()"> Prantwise District Business
                  Report</mat-option>
                <mat-option (click)="prantwiseAllTotalTalukawiseBusinessReport()"> Prantwise Taluka Business
                  Report</mat-option>

              </mat-select>
            </mat-form-field>


          </div>
        </form>
        <!-- <div style="display: flow-root;">
          <button style="margin-left: 2%;width: 250px ;" mat-raised-button color="primary" (click)="DateRepwise()" style="width: 250px;">
            Datewise/Representativewise
          </button>
          <button style="margin-left: 2%;width: 250px ;" mat-raised-button color="primary" (click)="Datewise()">
            Datewise
          </button>
          <button style="margin-left: 2%;width: 250px;" mat-raised-button color="primary" (click)="Monthwise()">
            Monthwise
          </button>
          <button style="width: 250px;margin-left: 2%; " mat-raised-button color="primary" (click)="offrepwise()">
            Office Representativewise
          </button>
          <button style="width: 250px; margin-top: 2%;" mat-raised-button color="primary" (click)="repwise()">
             Representativewise
          </button>
          <button style="width: 250px; margin-top: 2%;margin-left: 2%;" mat-raised-button color="primary" (click)="countrywise()">
            Countrywise
          </button>
          <button style="width: 250px; margin-top: 2%;margin-left: 2%;" mat-raised-button color="primary" (click)="prantwise()">
            Pranttwise
          </button>
          <button style="width: 250px; margin-top: 2%;margin-left: 2%;" mat-raised-button color="primary" (click)="statewise()">
            Statewise
          </button>
          <button style="width: 250px; margin-top: 2%;margin-left: 0%;" mat-raised-button color="primary" (click)="districtwise()">
            Districtwise
          </button>
          <button style="width: 250px; margin-top: 2%;margin-left: 2%;" mat-raised-button color="primary" (click)="districtandtalukawise()">
            Talukawise
          </button>
          <button style="width: 250px; margin-top: 2%;margin-left: 2%;" mat-raised-button color="primary" (click)="typewiseawise()">
            Typewise
          </button>
          <button style="width: 250px; margin-top: 2%;margin-left: 2%;" mat-raised-button color="primary" (click)="DateRepwise1()">
            New/Renew
          </button>
        
        </div> -->

      </mat-card>

      <!-- <mat-card>
        <mat-form-field appearance="fill" style="margin-top: 1%; margin-right: 2%">
          <mat-label>Enter a date range</mat-label>
          <mat-date-range-input [formGroup]="datewiseForm" [rangePicker]="pickerdatewise">
            <input matStartDate formControlName="start" placeholder="Start date" />
            <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getChangedDateDatewise()" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="pickerdatewise"></mat-datepicker-toggle>
          <mat-date-range-picker #pickerdatewise></mat-date-range-picker>

          <mat-error *ngIf="datewiseForm.controls.start.hasError('matStartDateInvalid')">Invalid start date
          </mat-error>
          <mat-error *ngIf="datewiseForm.controls.end.hasError('matEndDateInvalid')">Invalid end date
          </mat-error>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="Datewise()">
          Datewise
        </button>
      </mat-card> -->
      <!-- <mat-card>
        <button mat-raised-button color="primary" style="margin-left: 2%;"
          (click)="datewiseVarganidarRojmelReport()">Datetwise
          Varganidar Rojmel Report</button>
      </mat-card> -->

      <!-- <mat-card>
        <mat-form-field appearance="fill" style="margin-top: 1%; margin-right: 2%">
          <mat-label>Enter a date range</mat-label>
          <mat-date-range-input [formGroup]="monthwiseForm" [rangePicker]="pickermonthwise">
            <input matStartDate formControlName="start" placeholder="Start date" />
            <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getChangedDateMonthwise()" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="pickermonthwise"></mat-datepicker-toggle>
          <mat-date-range-picker #pickermonthwise></mat-date-range-picker>

          <mat-error *ngIf="monthwiseForm.controls.start.hasError('matStartDateInvalid')">Invalid start date
          </mat-error>
          <mat-error *ngIf="monthwiseForm.controls.end.hasError('matEndDateInvalid')">Invalid end date
          </mat-error>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="Monthwise()">
          Monthwise
        </button>
      </mat-card> -->

      <!-- <mat-card>
        <form [formGroup]="offrepForm">
          <mat-form-field appearance="fill" style="margin-top: 1%">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="pickerdateoffrep">
              <input matStartDate formControlName="start" placeholder="Start date" />
              <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getChangedDateOffRep()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerdateoffrep"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerdateoffrep></mat-date-range-picker>
          </mat-form-field>
          <mat-form-field appearance="fill" class="example-full-width" style="margin-left: 2%; margin-top: 1%">
            <mat-label>Office Representative Name</mat-label>
            <input matInput formControlName="off_rep_name" [matAutocomplete]="autooff_rep_name" />
            <button *ngIf="off_rep_name1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_off_rep_name()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autooff_rep_name="matAutocomplete">
              <mat-option (onSelectionChange)="getoff_rep_name($event, option)"
                *ngFor="let option of filteredOptions22 | async" [value]="option['office_rep_name']">
                {{ option["office_rep_name"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </form>
        <button mat-raised-button color="primary" (click)="offrepwise()">
          Office Representativewise
        </button>
      </mat-card> -->

      <!-- <mat-card>

        <button mat-raised-button color="primary" (click)="renewablereceiptdata()">
          Renew Remaining data
        </button>

        <button mat-raised-button color="primary" style="margin-left: 2%" (click)="repwiseAddress()">
          Representativewise Address List
        </button>
      </mat-card> -->
    </mat-tab>

    <mat-tab label="Subscribers Details">
      <form [formGroup]="subdetailsform">
        <div>
          <mat-form-field appearance="fill" style="margin-left: 3%;margin-top: 5%; width: 20%;">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [formGroup]="subdaterange" [rangePicker]="picker1">
              <input matStartDate formControlName="start" placeholder="Start date" />
              <input matEndDate formControlName="end" placeholder="End date"
                (dateChange)="getChangedDateRegistration()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-date-range-picker #picker1></mat-date-range-picker>

            <mat-error *ngIf="subdaterange.controls.start.hasError('matStartDateInvalid')">Invalid start date
            </mat-error>
            <mat-error *ngIf="subdaterange.controls.end.hasError('matEndDateInvalid')">Invalid end date
            </mat-error>
          </mat-form-field>

          <!-- Old Code -->
          <!-- <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Subscriber No.</mat-label>
            <input matInput formControlName="cust_id" [matAutocomplete]="autocustid" />
            <button *ngIf="cust_id" matSuffix mat-icon-button aria-label="Clear" (click)="reset_cust_id()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autocustid="matAutocomplete">
              <mat-option (onSelectionChange)="get_cust_id($event, option)"
                *ngFor="let option of filteredOptions11 | async" [value]="option['subno']">
                {{ option["subno"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field> -->


          <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Subscriber No.</mat-label>
            <mat-select formControlName="cust_id" multiple>
              <!-- Clear button -->
              <mat-select-trigger>
                {{ (subdetailsform.get('cust_id').value || []).join(', ') }}
              </mat-select-trigger>
              <mat-option *ngFor="let option of sub_sub_no_data" [value]="option.subno">
                {{ option.subno }}
              </mat-option>
            </mat-select>
            <button *ngIf="subdetailsform.get('cust_id').value?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_cust_ids()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>


          <!-- <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Receipt No.</mat-label>
            <input matInput formControlName="rcpt_no" [matAutocomplete]="autorcptno" />
            <button *ngIf="rcpt_no" matSuffix mat-icon-button aria-label="Clear" (click)="reset_rcpt_no()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autorcptno="matAutocomplete">
              <mat-option (onSelectionChange)="get_rcpt_no($event, option)"
                *ngFor="let option of filteredOptions10 | async" [value]="option['rcpt_no']">
                {{ option["rcpt_no"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field> -->


          <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Receipt No.</mat-label>
            <mat-select formControlName="rcpt_no" multiple>
              <mat-select-trigger>
                {{ (subdetailsform.get('rcpt_no').value || []).join(', ') }}
              </mat-select-trigger>
              <mat-option *ngFor="let option of sub_rcpt_no_data" [value]="option.rcpt_no">
                {{ option.rcpt_no }}
              </mat-option>
            </mat-select>
            <button *ngIf="subdetailsform.get('rcpt_no').value?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_rept_no()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>


          <!-- <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Voucher No</mat-label>
            <input matInput formControlName="v_no" [matAutocomplete]="autovno" />
            <button *ngIf="v_no" matSuffix mat-icon-button aria-label="Clear" (click)="reset_v_no()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autovno="matAutocomplete">
              <mat-option (onSelectionChange)="get_v_no($event, option)" *ngFor="let option of filteredOptions9 | async"
                [value]="option['crdt_voucher_no']">
                {{ option["crdt_voucher_no"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field> -->

          <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Voucher No</mat-label>
            <mat-select formControlName="v_no" multiple>
              <mat-select-trigger>
                {{ (subdetailsform.get('v_no')?.value || []).join(', ') }}
              </mat-select-trigger>
              <mat-option *ngFor="let option of sub_v_no_data" [value]="option.crdt_voucher_no">
                {{ option.crdt_voucher_no }}
              </mat-option>
            </mat-select>
            <button *ngIf="subdetailsform.get('v_no')?.value?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_v_no()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

        </div>


        <div>
          <!-- <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Subscriber Name</mat-label>
            <input matInput formControlName="sub_name" [matAutocomplete]="autosubnames" />
            <button *ngIf="sub_names1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_sub_names1()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autosubnames="matAutocomplete">
              <mat-option (onSelectionChange)="get_sub_name1($event, option)"
                *ngFor="let option of filteredOptions25 | async" [value]="option['name']">
                {{ option["name"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field> -->

          <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Subscriber Name</mat-label>
            <mat-select formControlName="sub_name" multiple>
              <mat-select-trigger>
                {{ (subdetailsform.get('sub_name')?.value || []).join(', ') }}
              </mat-select-trigger>
              <mat-option *ngFor="let option of sub_sub_name_data" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-select>
            <button *ngIf="subdetailsform.get('sub_name')?.value?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_sub_Name()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field style="margin-left: 3%; margin-top: 5%; width: 20%;" appearance="fill">
            <mat-label>Country</mat-label>
            <mat-select (selectionChange)="getCountry($event)" formControlName="country" multiple>
              <mat-option *ngFor="let c of countries" value="{{ c['country_name'] }}">{{ c["country_name"] }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field style="margin-left: 3%; margin-top: 5%; width: 20%;" appearance="fill">
            <mat-label>State</mat-label>
            <mat-select (selectionChange)="getState($event)" formControlName="state" multiple>
              <mat-option *ngFor="let c of states" value="{{ c['state_name'] }}">{{ c["state_name"] }}
              </mat-option>
            </mat-select>
            <span>{{ selectedState }}</span>
          </mat-form-field> -->

          <mat-form-field style="margin-left: 3%; margin-top: 5%; width: 20%;" appearance="fill">
            <mat-label>State</mat-label>
            <mat-select (selectionChange)="getStates($event)" formControlName="state" multiple>
              <mat-option *ngFor="let c of states" [value]="c">
                {{ c.state_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="margin-left: 3%; margin-top: 5%; width: 20%;" appearance="fill">
            <mat-label>District</mat-label>
            <mat-select (selectionChange)="getDistricts($event)" formControlName="dist_name" multiple>
              <mat-option *ngFor="let c of cities" value="{{ c['district_name'] }}">{{ c["district_name"] }}
              </mat-option>
            </mat-select>
            <span>{{ selectedCity }}</span>
          </mat-form-field>

        </div>

        <div>
          <mat-form-field style="margin-left: 3%; margin-top: 5%; width: 20%;" appearance="fill">
            <mat-label>Taluka</mat-label>
            <mat-select formControlName="tal_name" multiple>
              <mat-option *ngFor="let c of talukas" value="{{ c['taluka_name'] }}">{{ c["taluka_name"] }}</mat-option>
            </mat-select>
            <span>{{ selectedTaluka }}</span>
          </mat-form-field>


          <!-- <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Prant Name</mat-label>
            <input matInput formControlName="prant_name" [matAutocomplete]="prantname" />
            <button *ngIf="sub_names1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_sub_names1()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #prantname="matAutocomplete">
              <mat-option *ngFor="let option of prantdata" [value]="option['prant_name']">
                {{ option["prant_name"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field> -->

          <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Prant Name</mat-label>
            <mat-select formControlName="prant_name" multiple>
              <mat-select-trigger>
                {{ (subdetailsform.get('prant_name')?.value || []).join(', ') }}
              </mat-select-trigger>
              <mat-option *ngFor="let option of prantdata" [value]="option['prant_name']">
                {{ option['prant_name'] }}
              </mat-option>
            </mat-select>
            <button *ngIf="subdetailsform.get('prant_name')?.value?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetPrant()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field class="example-full-width" style="margin-left: 3%; width: 20%;  margin-top: 5%;">
            <mat-label>Subscription Type : </mat-label>
            <mat-select matNativeControl formControlName="subtype" multiple>
              <mat-option *ngFor="let option of subscriptiontype " [value]="option['subtype']">
                {{ option["subtype"] }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="example-full-width" style="margin-left: 3%; width: 20%;  margin-top: 5%;">
            <mat-label>Delivery Modewise : </mat-label>
            <mat-select matNativeControl formControlName="hastetapal" multiple>
              <mat-option *ngFor="let rep of delivery_mode" value="{{ rep['delivery_mode'] }}">
                {{ rep["delivery_mode"] }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>
        <div>
          <!-- <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Representative</mat-label>
            <input matInput formControlName="rep" [matAutocomplete]="autorep1" />
            <button *ngIf="rep" matSuffix mat-icon-button aria-label="Clear" (click)="reset_rep()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autorep1="matAutocomplete">
              <mat-option (onSelectionChange)="get_rep($event, option)" *ngFor="let option of filteredOptions7 | async"
                [value]="option['rep_name']">
                {{ option["rep_name"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field> -->

          <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Representative</mat-label>
            <mat-select formControlName="rep" multiple>
              <mat-select-trigger>
                {{ (subdetailsform.get('rep')?.value || []).join(', ') }}
              </mat-select-trigger>
              <mat-option *ngFor="let option of sub_rep_data" [value]="option.rep_name">
                {{ option.rep_name }}
              </mat-option>
            </mat-select>
            <button *ngIf="subdetailsform.get('rep')?.value?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetRep()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <!-- <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Office Representative</mat-label>
            <input matInput formControlName="off_rep" [matAutocomplete]="autooffrep" />
            <button *ngIf="off_rep" matSuffix mat-icon-button aria-label="Clear" (click)="reset_off_rep()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autooffrep="matAutocomplete">
              <mat-option (onSelectionChange)="get_off_rep($event, option)"
                *ngFor="let option of filteredOptions8 | async" [value]="option['office_rep_name']">
                {{ option["office_rep_name"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field> -->

          <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 3%; margin-top: 5%; width: 20%;">
            <mat-label>Office Representative</mat-label>
            <mat-select formControlName="off_rep" multiple>
              <mat-select-trigger>
                {{ (subdetailsform.get('off_rep')?.value || []).join(', ') }}
              </mat-select-trigger>
              <mat-option *ngFor="let option of sub_off_rep_data" [value]="option.office_rep_name">
                {{ option.office_rep_name }}
              </mat-option>
            </mat-select>
            <button *ngIf="subdetailsform.get('off_rep')?.value?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_off_reps()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field class="example-full-width" style="margin-left: 3%; width: 20%;  margin-top: 5%;">
            <mat-label>Show Active / Inactive : </mat-label>
            <mat-select matNativeControl formControlName="active_inactive" multiple>
              <mat-option [value]="'Y'">Active</mat-option>
              <mat-option [value]="'N'">Inactive</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <div> -->
          <button mat-raised-button matTooltip="search" class="btn btn-danger new-btn-danger"
            style="float: none; margin-left: 3%;" (click)="searchdeatils()">Search</button>

          <button mat-raised-button matTooltip="search" class="btn btn-danger new-btn-danger" style="float: none;"
            (click)="subscriberreport ()">Brief</button>

          <button mat-raised-button matTooltip="search" class="btn btn-danger new-btn-danger"
            style="float: none; margin-left: 3%; margin-top: 4%;" (click)="subscriberAddressLabelReport()">Address Label
            Report</button>

          <!-- <button mat-raised-button matTooltip="search" class="btn btn-danger new-btn-danger" style="float: none; margin-left: 3%; margin-top: 4%;"
              (click)="talukawiseSubscriberDetailsReport()">Talukawise Report</button> -->
          <!-- </div> -->
        </div>

      </form>
      <!-- <button
        style="margin-left: 3%"
        (click)="getCustReport()"
        mat-raised-button
        color="primary"
      >
        Get Report
      </button> -->

      <!-- OLD CODE -->
      <!-- <div style="margin-left: 40%;">
        <button mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger new-btn-danger"
          style="float: none;" (click)="excelToExport('Return_Report_List')">Export</button>
        <button mat-raised-button matTooltip="search" class="btn btn-danger new-btn-danger" style="float: none;"
          (click)="searchdeatils()">Search</button>
        <button mat-raised-button matTooltip="search" class="btn btn-danger new-btn-danger" style="float: none;"
          (click)="subscriberreport ()">Brief</button>

      </div> -->

      <!-- <div>
        <button mat-raised-button matTooltip="search" class="btn btn-danger new-btn-danger"   style="float: none;" (click)="searchdeatils()">Search</button>
      </div> -->

      <div style="margin-top: 3%;">
        <div class="mat-elevation-z8 matTable" tabindex="0" id="print-section">
          <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="rcpt_no">
              <th mat-header-cell *matHeaderCellDef>Receipt No.</th>
              <td mat-cell *matCellDef="let element"> {{element.rcpt_no}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="entry_date">
              <th mat-header-cell *matHeaderCellDef> Date </th>
              <td mat-cell *matCellDef="let element"> {{element.entry_date}} </td>
              <td mat-footer-cell *matFooterCellDef>Counts of Records:</td>
            </ng-container>

            <ng-container matColumnDef="subno">
              <th mat-header-cell *matHeaderCellDef> Subscription No </th>
              <td mat-cell *matCellDef="let element"> {{element.subno}} </td>
              <td mat-footer-cell *matFooterCellDef>{{ total_no_data }}</td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> Subscription Name </th>
              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="district">
              <th mat-header-cell *matHeaderCellDef> Place </th>
              <td mat-cell *matCellDef="let element"> {{element.district}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="subscription_type">
              <th mat-header-cell *matHeaderCellDef> Subscription Type </th>
              <td mat-cell *matCellDef="let element"> {{element.subscription_type}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="rcpt_type">
              <th mat-header-cell *matHeaderCellDef> Is_Receipt </th>
              <td mat-cell *matCellDef="let element"> {{element.rcpt_type}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="sub_perid_from_date">
              <th mat-header-cell *matHeaderCellDef> Subscription From Date</th>
              <td mat-cell *matCellDef="let element"> {{element.sub_perid_from_date}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="sub_perid_to_date">
              <th mat-header-cell *matHeaderCellDef> Perid To Date</th>
              <td mat-cell *matCellDef="let element"> {{element.sub_perid_to_date}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="delivery_mode">
              <th mat-header-cell *matHeaderCellDef> Delivery Mode </th>
              <td mat-cell *matCellDef="let element"> {{element.delivery_mode}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="distribution_rep">
              <th mat-header-cell *matHeaderCellDef> Distribution Representative Name </th>
              <td mat-cell *matCellDef="let element"> {{element.distribution_rep}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="temp_rcpt_no">
              <th mat-header-cell *matHeaderCellDef> Temp Receipt No</th>
              <td mat-cell *matCellDef="let element"> {{element.temp_rcpt_no}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="temp_rcpt_date">
              <th mat-header-cell *matHeaderCellDef> Date </th>
              <td mat-cell *matCellDef="let element"> {{element.temp_rcpt_date}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="rep_name">
              <th mat-header-cell *matHeaderCellDef> Representative Name</th>
              <td mat-cell *matCellDef="let element"> {{element.rep_name}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="office_rep_name">
              <th mat-header-cell *matHeaderCellDef> Office Representative Name </th>
              <td mat-cell *matCellDef="let element"> {{element.office_rep_name}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="total_amt">
              <th mat-header-cell *matHeaderCellDef> Total Amount </th>
              <td mat-cell *matCellDef="let element"> {{element.total_amt}} </td>
              <td mat-footer-cell *matFooterCellDef>{{getTotalTotalAmount()}}</td>
            </ng-container>

            <ng-container matColumnDef="discount">
              <th mat-header-cell *matHeaderCellDef> Discount </th>
              <td mat-cell *matCellDef="let element"> {{element.discount}} </td>
              <td mat-footer-cell *matFooterCellDef>{{getTotalDiscountAmount()}}</td>
            </ng-container>

            <ng-container matColumnDef="net_amt">
              <th mat-header-cell *matHeaderCellDef> Net Amount </th>
              <td mat-cell *matCellDef="let element"> {{element.net_amt}} </td>
              <td mat-footer-cell *matFooterCellDef> {{getTotalNetAmount()}} </td>
            </ng-container>

            <ng-container matColumnDef="rep_com_amt">
              <th mat-header-cell *matHeaderCellDef> Rrpresentative Commission </th>
              <td mat-cell *matCellDef="let element"> {{element.rep_com_amt}}</td>
              <td mat-footer-cell *matFooterCellDef>{{getTotalRepComAmount()}}</td>
            </ng-container>

            <ng-container matColumnDef="crdt_voucher_no">
              <th mat-header-cell *matHeaderCellDef> Voucher No </th>
              <td mat-cell *matCellDef="let element"> {{element.crdt_voucher_no}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="crdt_voucher_entry_date">
              <th mat-header-cell *matHeaderCellDef> Voucher Entry Date </th>
              <td mat-cell *matCellDef="let element"> {{element.crdt_voucher_entry_date}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="magzine_edition">
              <th mat-header-cell *matHeaderCellDef> Edition </th>
              <td mat-cell *matCellDef="let element"> {{element.magzine_edition}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="remark">
              <th mat-header-cell *matHeaderCellDef> Remark </th>
              <td mat-cell *matCellDef="let element"> {{element.remark}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="remark1">
              <th mat-header-cell *matHeaderCellDef> Remark1 </th>
              <td mat-cell *matCellDef="let element"> {{element.remark1}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="remark2">
              <th mat-header-cell *matHeaderCellDef> Remark2 </th>
              <td mat-cell *matCellDef="let element"> {{element.remark2}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="rcptstopdate">
              <th mat-header-cell *matHeaderCellDef> Receipt Stop Date </th>
              <td mat-cell *matCellDef="let element"> {{element.rcptstopdate}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="rcptstopremark">
              <th mat-header-cell *matHeaderCellDef> Receipt Stop Remark </th>
              <td mat-cell *matCellDef="let element"> {{element.rcptstopremark}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="rcptstartdate">
              <th mat-header-cell *matHeaderCellDef> Receipt Start Date</th>
              <td mat-cell *matCellDef="let element"> {{element.rcptstartdate}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="rcptstartremark">
              <th mat-header-cell *matHeaderCellDef> Receipt Start Remark </th>
              <td mat-cell *matCellDef="let element"> {{element.rcptstartremark}} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th colspan="4" mat-header-cell *matHeaderCellDef> Action </th>
              <td colspan="4" mat-cell *matCellDef="let element">
                <button *ngIf="element['is_active'] == 'N'" style="color: green;" class="btn btn-primary"
                  mat-raised-button type="button" (click)="inactiveReceipt1(element)">
                  Active
                </button>
                <button *ngIf="element['is_active'] == 'Y'" style="color: red;" class="btn btn-primary"
                  mat-raised-button type="button" (click)="inactiveReceipt1(element)">
                  Inactive
                </button>
                <button class="btn btn-danger" style="margin-top: 4px;" mat-raised-button type="button"
                  (click)="returnReceipt(element)">
                  Return
                </button>
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
          </table>
        </div>

        <mat-paginator [pageSize]="13000" (page)="handlePageEvent($event)" [length]="length"
          [pageSizeOptions]="[500, 1000, 3000, 7000, 12000, 15000, 20000]" showFirstLastButtons
          aria-label="Select page of periodic elements">
        </mat-paginator>

        <button mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger new-btn-danger"
          style="float: none; margin-left: 40%; margin-top: 2%;"
          (click)="excelToExport('Return_Report_List')">Export</button>

        <!-- <button class="noPrint" style="margin-top: -5%; margin-left: 50%;" mat-raised-button color="primary"
            printSectionId="print-section" [useExistingCss]="true" ngxPrint>
            Print
          </button> -->

        <button class="noPrint" style="margin-top: -5%; margin-left: 50%" mat-raised-button color="primary"
          (click)="printPage()">
          Print
        </button>

      </div>
    </mat-tab>

    <mat-tab label="Hand Delivary Ledger">
      <mat-card>
        <div class="form-row">
          <mat-form-field appearance="fill" style="width: 40%;">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [formGroup]="dateform" [rangePicker]="pickerdist">
              <input matStartDate formControlName="start" placeholder="Start date" />
              <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getChangedDatedist()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerdist"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerdist></mat-date-range-picker>
            <mat-error *ngIf="
                                          dateform.controls.start.hasError(
                                            'matStartDateInvalid'
                                          )
                                        ">Invalid start date</mat-error>
            <mat-error *ngIf="
                                          dateform.controls.end.hasError('matEndDateInvalid')
                                        ">Invalid end date</mat-error>
          </mat-form-field>
        </div>
        <!-- <button mat-raised-button type="button" style="margin-bottom: 1%;" color="primary" (click)="openDistribution()">
          Distribution
        </button> -->

        <button mat-raised-button type="button" style=" background-color: rgb(7, 135, 240); font-size: 18px;"
          color="primary" (click)="vatnavalDistribution()">
          हस्ते वाटणावळ
        </button>
      </mat-card>


      <mat-card>
        <!-- <div
          style="text-align: center; font-weight: 600; font-size: 18px; background-color: rgb(7, 135, 240); padding: 10px; color: white;">
          हस्ते वाटणावळ
        </div> -->
        <div class="tableFixHead" style="margin-top: 1%;">
          <table class="table table-bordered ">
            <thead>
              <tr>
                <th style="text-align: center; font-size: 14px;">अ.क्र</th>
                <th style="text-align: center; font-size: 14px;">महिना</th>
                <th style="text-align: center; font-size: 14px;">अंक दिनांक</th>
                <th style="text-align: center; font-size: 14px;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of vatnavalData; let i = index">
                <td style="text-align: center; font-size: 12px;">{{ i + 1}}</td>
                <td style="text-align: center; font-size: 12px;">{{ item['monthName'] }} - {{ item['year'] }}</td>
                <td style="text-align: center; font-size: 12px;">{{ item['added_date_time'] | date:"dd-MM-yyyy" }}</td>
                <td style="text-align: center;"><button mat-icon-button type="button" class="btn-sm btn-outline-primary"
                    matTooltip="View" (click)="viewVatnaval(item)"><mat-icon>visibility</mat-icon></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>

    </mat-tab>

    <mat-tab label="Masters Entry">
      <mat-card style="margin-top: 20px; border-radius: 10px; padding-bottom: 30px">
        <h2 style="text-align: center">Add New Subscription Type</h2>
        <form [formGroup]="subtypeform" (ngSubmit)="addsubtype()">
          <div class="form-row">
            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 7%; width: 35%">
              <mat-label>Subscription Type</mat-label>
              <input matInput formControlName="subtype" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 5%; width: 35%">
              <mat-label>Price</mat-label>
              <input matInput type="number" formControlName="price" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 7%; width: 35%">
              <mat-label>Date</mat-label>
              <input matInput type="date" formControlName="date" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 5%; width: 35%">
              <mat-label>Subscription Short Name</mat-label>
              <input matInput formControlName="shortname" />
            </mat-form-field>
          </div>
          <div class="form-group">
            <button style="margin-left: 5%; margin-right: 25%; width: 60%" [disabled]="subtypeform.invalid"
              type="submit" mat-raised-button color="primary" class="btn btn-primary btn-block">
              Add Subscrition Type
            </button>
          </div>
        </form>
      </mat-card>

      <mat-card style="margin-top: 20px">
        <table class="table table-striped fixedtable text-center">
          <thead>
            <tr>
              <th>Subtype</th>
              <th>Price</th>
              <th>Date</th>
              <th>Shortname</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of this.subscriptiontype">
              <td>{{ item["subtype"] }}</td>
              <td>{{ item["price"] }}</td>
              <td>
                <span *ngIf="item['updated_date'] === '0000-00-00 00:00:00'">{{ item["date"] | date: "dd-MM-yyy"
                  }}</span>
                <span *ngIf="item['updated_date'] !== '0000-00-00 00:00:00'">{{ item["updated_date"] | date: "dd-MM-yyy"
                  }}</span>
              </td>
              <td>{{item.short_name}}</td>
              <td style="display: flex; justify-content: center">
                <button class="btn-sm btn-outline-info" matTooltip="Update" type="button" (click)="updatesubtype(item)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button matTooltip="Update" class="btn-sm btn-outline-info" mat-raised-button
                  (click)="deletemaster(item)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </mat-card>
    </mat-tab>

    <mat-tab label="Add Delivery Mode">
      <mat-card>
        <form [formGroup]="adddeliverymode" (ngSubmit)="addDelivery()">
          <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%" class="example-full-width">
            <mat-label>Delivery Mode</mat-label>
            <input matInput formControlName="deliverymode" />
          </mat-form-field>

          <button class="btn btn-primary" mat-raised-button color="primary"
            style="margin-left: 9%; margin-right: 47%; width: 10%; margin-top: -6%;" type="submit">
            Save
          </button>


          <button *ngIf="delivery_mode_update_btn == true" mat-raised-button class="btn btn-primary" color="primary"
            style="margin-left: 15%; margin-right: 35%; width: 10%;  margin-top: -6%;"
            (click)="update_delivery_modeapi()">
            Update
          </button>
        </form>

        <div class="tableFixHead1" style="padding: 20px 20px;">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Sr no</th>
                <th>Delivery Mode</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of distributionmodesData1; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item['delivery_mode'] }}</td>
                <td>
                  <!-- <button style="margin-right: 2%;" matTooltip="Delete" class="btn-sm btn-outline-info"
                    (click)="delivery_mode1(item['id'])">
                    <mat-icon>close</mat-icon>
                  </button> -->
                  <button style="margin-right: 2%;" matTooltip="update" class="btn-sm btn-outline-info"
                    (click)="update_delivery_mode1(item)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button matTooltip="delete" class="btn-sm btn-outline-danger" (click)="delivery_mode1(item['id'])">
                    <mat-icon>close</mat-icon>
                  </button>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>

      <mat-card class="cards" style="margin-top: 20px">
        <form [formGroup]="adddeliverymodeform" (ngSubmit)="addSubDelivery()">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%" appearance="outline">
              <mat-label>Delivery Mode</mat-label>
              <mat-select formControlName="deliverymode">
                <mat-option *ngFor="let mode of this.delivery_mode" [value]="mode['id']">
                  {{ mode["delivery_mode"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%" class="example-full-width">
              <mat-label>Distribution Mode</mat-label>
              <input matInput formControlName="subdeliverymode" />
            </mat-form-field>
          </div>
          <div class="form-group">
            <button *ngIf="!dis_mode_show1" mat-raised-button class="btn btn-primary" mat-raised-button color="primary"
              style="margin-left: 15%; margin-right: 35%; width: 40%">
              Save
            </button>
            <button type="button" *ngIf="dis_mode_show1" mat-raised-button class="btn btn-info"
              (click)="updateaddSubDelivery()" style="margin-left: 15%; margin-right: 35%; width: 40%">
              Update
            </button>
          </div>
        </form>
        <div class="tableFixHead1" style="padding: 20px 20px;">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Delivery Mode</th>
                <th>Distribution Mode</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of distributionmodesData">
                <td>{{ item['delivery_mode'] }}</td>
                <td>{{ item['sub_delivery_mode'] }}</td>
                <td>
                  <button style="margin-right: 2%;" matTooltip="Update" class="btn-sm btn-outline-info"
                    (click)="updatedismode(item['id'])">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button matTooltip="Remove" class="btn-sm btn-outline-danger" (click)="removedismode(item['id'])">
                    <mat-icon>close</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>

      <mat-card class="cards" style="margin-top: 5%; padding: 20px 10px">
        <h1 style="text-align: center">Add Distribution Mode</h1>
        <form [formGroup]="addsubdeliverymodeform" (ngSubmit)="addSubDeliveryofSub()">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 25%" appearance="outline">
              <mat-label>Distribution Mode</mat-label>
              <mat-select formControlName="deliverymode">
                <mat-option (onSelectionChange)="distributionMode($event, mode)"
                  *ngFor="let mode of this.subDeliveryModeData" [value]="mode['id']">
                  {{ mode["sub_delivery_mode"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" style="margin-left: 5%; width: 25%" class="example-full-width">
              <mat-label>Sub Distribution Mode</mat-label>
              <input matInput formControlName="subdeliverymode" />
            </mat-form-field>
            <mat-form-field appearance="outline" style="margin-left: 5%; width: 10%" class="example-full-width">
              <mat-label>Vajan</mat-label>
              <input matInput formControlName="vajan" />
            </mat-form-field>
            <mat-form-field appearance="outline" style="margin-left: 5%; width: 10%" class="example-full-width">
              <mat-label>Rate</mat-label>
              <input matInput formControlName="rate" />
            </mat-form-field>
          </div>
          <div class="form-group">
            <button *ngIf="!this.sub_dis_mode_show" mat-raised-button class="btn btn-primary" mat-raised-button
              color="primary" style="margin-left: 15%; margin-right: 35%; width: 40%">
              Save
            </button>
            <button *ngIf="this.sub_dis_mode_show" type="button" mat-raised-button class="btn btn-info"
              (click)="updateaddSubDeliveryofSub()" style="margin-left: 15%; margin-right: 35%; width: 40%">
              Update
            </button>
          </div>
        </form>
        <div class="tableFixHead1" style="padding: 20px 20px;">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Distribution Mode</th>
                <th>Sub Distribution Mode</th>
                <th>Vajan</th>
                <th>Rate</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of subdistributionmodesData">
                <td>{{ item['sub_delivery_mode'] }}</td>
                <td>{{ item['subdeliverymode'] }}</td>
                <td>{{ item['vajan'] || 0}}</td>
                <td>{{ item['rate'] || 0}}</td>
                <td>
                  <button style="margin-right: 2%;" matTooltip="Update" class="btn-sm btn-outline-info"
                    (click)="updatesubdismode(item['id'])">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button matTooltip="Remove" class="btn-sm btn-outline-danger" (click)="removesubdismode(item['id'])">
                    <mat-icon>close</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>

      <mat-card>
        <h1 style="text-align: center">Assign Distribution Representative</h1>
        <form [formGroup]="AssignDisRepForm">
          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 5%">
              <mat-label>Distribution Representative</mat-label>
              <input matInput formControlName="disrep1" [matAutocomplete]="autodisrep" />
              <mat-autocomplete autoActiveFirstOption #autodisrep="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions26 | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>


            <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 5%">
              <mat-label>Distribution Mode</mat-label>
              <input matInput formControlName="dismode" [matAutocomplete]="autodismode" />
              <mat-autocomplete autoActiveFirstOption #autodismode="matAutocomplete">
                <mat-option (onSelectionChange)="distributionMode($event, option)"
                  *ngFor="let option of filteredOptions27 | async" [value]="option['sub_delivery_mode']">
                  {{ option["sub_delivery_mode"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 2%">
              <mat-label>Distribution Sub Mode</mat-label>
              <input matInput formControlName="dissubmode" [matAutocomplete]="autodissubmode" />
              <mat-autocomplete autoActiveFirstOption #autodissubmode="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions28 | async" [value]="option['subdistributionmode']">
                  {{ option["subdistributionmode"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="form-group">
            <button *ngIf="!dis_mode_show" mat-raised-button class="btn btn-primary" type="button" mat-raised-button
              color="primary" style="margin-left: 15%; margin-right: 35%; width: 40%"
              (click)="assignDistributionMode()">
              Save
            </button>
            <button *ngIf="dis_mode_show" mat-raised-button class="btn btn-info" type="button"
              style="margin-left: 15%; margin-right: 35%; width: 40%" (click)="updateassignDistributionMode()">
              Update
            </button>
          </div>
        </form>
      </mat-card>

      <mat-card>
        <div class="tableFixHead" style="padding: 20px 20px;" id="repListSection1">
          <div style="width: 100%; text-align: right; padding: 10px 5% 10px 0;">
            <button type="button" class="btn btn-danger" style="width: 10%;" (click)="printSection('repListSection1')">
              Print
            </button>
          </div>

          <table class="table table-striped text-center">
            <thead>
              <tr>
                <td>Distribution Representative</td>
                <td>Distribution Mode</td>
                <td>Distribution Sub Mode</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of distributionmoderepData">
                <td>{{ item['dis_rep'] }}</td>
                <td>{{ item['dis_mode'] }}</td>
                <td>{{ item['dis_sub_mode'] }}</td>
                <td>
                  <button style="margin-right: 2%;" matTooltip="Update" class="btn-sm btn-outline-info"
                    (click)="updateDisMode(item['id'])">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button matTooltip="Remove" class="btn-sm btn-outline-danger"
                    (click)="removeassigndismode(item['id'])">
                    <mat-icon>close</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>
    </mat-tab>

    <!-- <mat-tab label="Add Sprem Bhet">
      <mat-card class="mt-5">
        <form class="form" [formGroup]="sbhet">
          <div class="form-row">

            <mat-form-field class="example-full-width" style="width: 25%; margin-left: 7%; margin-top: 2%">
              <mat-label>Representative Name:</mat-label>
              <input #myInput matInput formControlName="id" [matAutocomplete]="issuesellername" />
              <mat-autocomplete #issuesellername="matAutocomplete">
                <mat-option (onSelectionChange)="selected_rep_name1($event, option)"
                  *ngFor="let option of filteredOptions | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field style="margin-left: 5%; width: 25%;margin-top: 10px;" appearance="outline">
              <mat-label>Select date</mat-label>
              <input matInput required formControlName="date" [matDatepicker]="pickerpubdatex" />
              <mat-datepicker-toggle matSuffix [for]="pickerpubdatex"></mat-datepicker-toggle>
              <mat-datepicker #pickerpubdatex></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 25%" class="example-full-width"
              appearance="outline">
              <mat-label>जाहिरात सप्रेम भेट</mat-label>
              <input type="number" formControlName="jahiratsbhet" matInput />
            </mat-form-field>
            <mat-form-field style="margin-left: 5%; margin-top: 10px; width: 25%" class="example-full-width"
              appearance="outline">
              <mat-label>अभिकर्ता सप्रेम भेट</mat-label>
              <input type="number" formControlName="issuesbhet" matInput />
            </mat-form-field>

            <mat-form-field style="margin-left: 5%; margin-top: 10px; width: 25%" class="example-full-width"
              appearance="outline">
              <mat-label>वर्गणी सप्रेम भेट</mat-label>
              <input type="number" formControlName="sbhet" matInput />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 25%; margin-left: 7%">
              <mat-label> जादा अंक </mat-label>
              <input matInput type="text" formControlName="input_value" />
            </mat-form-field>

            <mat-form-field class="example-full-width" appearance="outline" style="width: 25%; margin-left: 5%">
              <mat-label> जादा विक्री </mat-label>
              <input matInput type="text" formControlName="input_value1" />
            </mat-form-field>

            <mat-form-field class="example-full-width" appearance="outline" style="width: 25%; margin-left: 5%">
              <mat-label> जादा सप्रेमभेट </mat-label>
              <input matInput type="text" formControlName="input_value2" />
            </mat-form-field>
          </div>

          <div class="form-group d-flex">

            <button style="margin-left: 80px; width: 20%" [disabled]="sbhet.invalid" class="btn btn-danger btn-block"
              (click)="addsbhet()">
              Add Saprem Bhet
            </button>

            <button style=" width: 20%; margin-left: 80px;" *ngIf="updatesbhet == true"
              class="btn btn-primary btn-block" (click)="updatesbhetdata()">
              Update Saprem Bhet
            </button>
            <div style=" width: 20%; margin-left: 80px;">
              <button *ngIf="serachParam!=null" style="background: #b1a3c2;" matTooltip="Make Active"
                class="btn-sm btn-outline-info" (click)="setOriginalData()" mat-raised-button>
                <mat-icon>close</mat-icon>{{serachParam}}
              </button>

            </div>
          </div>
        </form>


        <div>

          <div class="tableFixHead">
            <table class="table table-striped" style="width: 120%;">
              <thead style="text-align: center;">
                <tr>
                  <th>Sr</th>
                  <th>Representative Name</th>
                  <th>Issue Name</th>
                  <th>Start Date</th>
                  <th>जाहिरात</th>
                  <th>अभिकर्ता</th>
                  <th>वर्गणी</th>
                  <th>जादा अंक</th>
                  <th>जादा विक्री</th>
                  <th>जादा सप्रेमभेट</th>
                  <th>एकूण</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody style="text-align: center;">
                <tr *ngFor="let item of searchData;  let i = index">
                  <td>{{i+1}}</td>
                  <td>{{ item['issueSellerName' ] }}</td>
                  <td>{{ item['issueName'] }}</td>
                  <td>{{ item.start_date | date: 'dd-MM-yyyy' }} - {{ item.end_date | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ item['jahirat_sbhet'] }}</td>
                  <td>{{ item['issues_bhet'] }}</td>
                  <td>{{ item['s_bhet'] }}</td>
                  <td> {{item['input_value'] || 0}}</td>
                  <td> {{item['input_value1'] || 0}}</td>
                  <td> {{item['input_value2'] || 0}}</td>
                  <td> {{item['saprembhet_total']}}</td>


                  <td>
                    <button *ngIf="item.active_status=='DEACTIVE'" style="background: #f5b0b0;" matTooltip="Make Active"
                      class="btn-sm btn-outline-info" mat-raised-button (click)="updateActiveStatus('ACTIVE',item.id)">
                      <mat-icon>close</mat-icon>
                    </button>
                    <button *ngIf="item.active_status=='ACTIVE'" style="background: #a7eba6;" matTooltip="Make Deactive"
                      class="btn-sm btn-outline-info" mat-raised-button
                      (click)="updateActiveStatus('DEACTIVE',item.id)">
                      <mat-icon>check</mat-icon>
                    </button>
                    <button matTooltip="Update" class="btn-sm btn-outline-info" mat-raised-button
                      style="margin-left: 3px;" (click)="updateSbhetData(item)">
                      <mat-icon>edit</mat-icon>
                    </button>

                    <button matTooltip="Update" class="btn-sm btn-outline-info" mat-raised-button
                      style="margin-left: 3px;" (click)="deletesbhet(item)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </mat-card>
    </mat-tab> -->

    <mat-tab label="Return Receipt Report">
      <mat-card>
        <form [formGroup]="returnrcptform">
          <div>
            <mat-form-field appearance="fill" style="margin-top: 1%; width:20%;">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [formGroup]="rtnrcptdaterange" [rangePicker]="pickerrtn" [min]="financialYearMin"
                [max]="financialYearMax">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateReturnRcpt()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerrtn"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerrtn></mat-date-range-picker>

              <mat-error *ngIf="
                  rtnrcptdaterange.controls.start.hasError('matStartDateInvalid')
                ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                  rtnrcptdaterange.controls.end.hasError('matEndDateInvalid')
                ">Invalid end date
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="example-full-width"
              style="margin-left: 2%; margin-top: 1%; width:20%;">
              <mat-label>Subscriber Name</mat-label>
              <input matInput formControlName="subname" [matAutocomplete]="autosubname" />
              <button *ngIf="sub_name" matSuffix mat-icon-button aria-label="Clear" (click)="reset_sub_name()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete autoActiveFirstOption #autosubname="matAutocomplete">
                <mat-option (onSelectionChange)="get_sub_name($event, option)"
                  *ngFor="let option of filteredOptions14 | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="fill" class="example-full-width"
              style="margin-left: 2%; margin-top: 1%; width:20%;">
              <mat-label>Representative</mat-label>
              <input matInput formControlName="rep" [matAutocomplete]="autorep3" />
              <button *ngIf="rep2" matSuffix mat-icon-button aria-label="Clear" (click)="reset_rtn_rep()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete autoActiveFirstOption #autorep3="matAutocomplete">
                <mat-option (onSelectionChange)="get_rtn_rep($event, option)"
                  *ngFor="let option of filteredOptions15 | async" [value]="option['rep_name']">
                  {{ option["rep_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="fill" class="example-full-width"
              style="margin-left: 2%; margin-top: 1%; width:20%;">
              <mat-label>Office Representative</mat-label>
              <input matInput formControlName="off_rep" [matAutocomplete]="autooffrep1" />
              <button *ngIf="off_rep1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_off_rep1()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete autoActiveFirstOption #autooffrep1="matAutocomplete">
                <mat-option (onSelectionChange)="get_off_rep1($event, option)"
                  *ngFor="let option of filteredOptions16 | async" [value]="option['office_rep_name']">
                  {{ option["office_rep_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>



          </div>


          <!-- <mat-form-field
            appearance="fill"
            class="example-full-width"
            style="margin-left: 3%; margin-top: 1%"
          >
            <mat-label>Receipt No.</mat-label>
            <input
              matInput
              formControlName="rcpt_no"
              [matAutocomplete]="autorcptno"
            />
            <button
              *ngIf="rcpt_no"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="reset_rcpt_no()"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete
              autoActiveFirstOption
              #autorcptno="matAutocomplete"
            >
              <mat-option
                (onSelectionChange)="get_rcpt_no($event, option)"
                *ngFor="let option of filteredOptions10 | async"
                [value]="option['rcpt_no']"
              >
                {{ option["rcpt_no"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field> -->


          <mat-form-field appearance="fill" class="example-full-width" style="margin-top: 2%;width:20%">
            <mat-label>District</mat-label>
            <input matInput formControlName="district" [matAutocomplete]="autodst" />
            <button *ngIf="district1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_district()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autodst="matAutocomplete">
              <mat-option (onSelectionChange)="get_district($event, option)"
                *ngFor="let option of filteredOptions17 | async" [value]="option['district']">
                {{ option["district"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 2%; margin-top: 2%;width:20%">
            <mat-label>Taluka</mat-label>
            <input matInput formControlName="taluka" [matAutocomplete]="autotlk" />
            <button *ngIf="taluka1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_taluka()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autotlk="matAutocomplete">
              <mat-option (onSelectionChange)="get_taluka($event, option)"
                *ngFor="let option of filteredOptions18 | async" [value]="option['taluka']">
                {{ option["taluka"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 2%; margin-top: 2%;width:20%">
            <mat-label>State</mat-label>
            <input matInput formControlName="state" [matAutocomplete]="autostt" />
            <button *ngIf="state1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_state()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autostt="matAutocomplete">
              <mat-option (onSelectionChange)="get_state($event, option)"
                *ngFor="let option of filteredOptions19 | async" [value]="option['state']">
                {{ option["state"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="fill" class="example-full-width"
            style="margin-left: 2%; margin-top: 2%;width:20%">
            <mat-label>Country</mat-label>
            <input matInput formControlName="country" [matAutocomplete]="autoct" />
            <button *ngIf="country1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_country()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autoct="matAutocomplete">
              <mat-option (onSelectionChange)="get_country($event, option)"
                *ngFor="let option of filteredOptions20 | async" [value]="option['country']">
                {{ option["country"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </form>
        <div class="tableFixHead" id="excel-table1">
          <button mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger new-btn-danger"
            (click)="exportexcel1('Return_Report_List')">Export</button>
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>एन्ट्री दि</th>
                <th>अंक दि</th>
                <th>ग्राहक क्र</th>
                <th>ग्राहकाचे नाव</th>
                <th>ठिकाण</th>
                <th>संपर्क</th>
                <th>परत येणाचे कारण</th>
                <th>प्रतिनिधींचे नाव</th>
                <th>कार्यालय प्रतिनिधींचे नाव</th>
                <th>कार्यवाही</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Filteredreturnrcptdata">
                <td>{{ item["date"] | date: "dd-MM-yyy" }}</td>
                <td>{{ item["ank_date"] | date: "dd-MM-yyy" }}</td>
                <td>{{ item["subno"] }}</td>
                <td>{{ item["name"] }}</td>
                <td>{{ item["district"] }}</td>
                <td>{{ item["mobileNumber"] }}</td>
                <td>{{ item["reason"] }}</td>
                <td>{{ item["rep_name"] }}</td>
                <td>{{ item['office_rep_name'] }}</td>
                <td>{{ item["karyavahi"] }}</td>
                <td>
                  <button class="btn-sm btn-outline-info" type="button" (click)="updateReturnReceipt(item)">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>
    </mat-tab>

    <mat-tab label="Subscription Invoice">
      <button style="margin-left: 3%; margin-top: 5%" (click)="newCustSubInvoice = !newCustSubInvoice" mat-raised-button
        color="warn">
        New Invoice
      </button>

      <mat-form-field class="example-form-field" *ngIf="newCustSubInvoice" appearance="fill"
        style="margin-left: 3%; margin-top: 5%">
        <mat-label>Customer No.</mat-label>
        <input matInput type="text" [(ngModel)]="cust_id" (ngModelChange)="get_cust_id($event)" />
        <button *ngIf="cust_id" matSuffix mat-icon-button aria-label="Clear" (click)="reset_cust_id()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <span *ngIf="newCustSubInvoice" style="margin-left: 3%; font-size: large; font-weight: bold">
        OR
      </span>

      <mat-form-field *ngIf="newCustSubInvoice" class="example-form-field" appearance="fill"
        style="margin-left: 3%; margin-top: 5%">
        <mat-label>Customer Mobile No.</mat-label>
        <input matInput type="tel" [(ngModel)]="cust_mobile" #mobileValidate maxlength="10"
          (ngModelChange)="getcust_mobile($event)" />
        <button *ngIf="cust_mobile" matSuffix mat-icon-button aria-label="Clear" (click)="reset_cust_mobile()">
          <mat-icon>close</mat-icon>
          <mat-hint align="end">{{ mobileValidate.value.length }} / 10</mat-hint>
        </button>
      </mat-form-field>

      <button *ngIf="newCustSubInvoice" style="margin-left: 3%" (click)="getSubscriber()" mat-raised-button
        color="primary">
        Find
      </button>
      <!-- <div *ngIf="!displayNewSubscriber && newCustSubInvoice" style="
          margin-left: 3%;
          margin-top: 2%;
          margin-bottom: 2%;
          text-align: center;
        ">
        <span>No subscriber details available.</span>
      </div> -->

      <div *ngIf="newCustSubInvoice" style="margin-top: 20px" class="tableFixHead">
        <button type="button" (click)="exportexcel()" class="btn btn-danger">
          Export
        </button>
        <table class="table table-striped text-center">
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>Sub No</th>
              <th>Name</th>
              <th>Receipt Number</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of getSubDetails; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item["subno"] }}</td>
              <td>{{ item["name"] }}</td>
              <td>{{ item["rcpt_no"] }}</td>
              <td>
                <button type="button" (click)="ViewCustInvoiceSubscription(book)" class="btn btn-danger">
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div *ngIf="displayNewSubscriber && newCustSubInvoice" style="
          margin-left: 3%;
          margin-top: 2%;
          margin-bottom: 2%;
          text-align: center;
        ">
        <span>You are generating invoice for :
          <b> {{ getSubDetails[0]["name"] }}</b>
        </span>
      </div>

      <mat-form-field *ngIf="displayNewSubscriber && newCustSubInvoice" appearance="fill" style="margin-left: 3%">
        <mat-label>Invoice Type</mat-label>
        <mat-select (selectionChange)="getInvoiceType($event)">
          <mat-option value="Y">GST</mat-option>
          <mat-option value="N">Non-GST</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="example-form-field" *ngIf="
          displaygstNumberInput && displayNewSubscriber && newCustSubInvoice
        " appearance="fill" style="margin-left: 3%">
        <mat-label>GST Number : </mat-label>
        <input matInput type="text" [(ngModel)]="gstNumber" (ngModelChange)="getGstNumber($event)" />
      </mat-form-field>

      <button *ngIf="displayNewSubscriber && newCustSubInvoice" style="margin-left: 3%" (click)="getSubInvoice()"
        mat-raised-button color="primary">
        Generate
      </button>

      <mat-form-field *ngIf="!newCustSubInvoice" appearance="fill" style="margin-top: 5%; margin-left: 3%">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [formGroup]="CustSubGeneratedInvoice" [rangePicker]="picker5" [min]="financialYearMin"
          [max]="financialYearMax">
          <input matStartDate formControlName="start" placeholder="Start date" />
          <input matEndDate formControlName="end" placeholder="End date"
            (dateChange)="getCustInvoiceDateRangeSubscription()" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
        <mat-date-range-picker #picker5></mat-date-range-picker>

        <mat-error *ngIf="
            CustSubGeneratedInvoice.controls.start.hasError(
              'matStartDateInvalid'
            )
          ">Invalid start date</mat-error>
        <mat-error *ngIf="
            CustSubGeneratedInvoice.controls.end.hasError('matEndDateInvalid')
          ">Invalid end date</mat-error>
      </mat-form-field>

      <button *ngIf="!newCustSubInvoice" style="margin-left: 3%" (click)="getCustSubInvoice()" mat-raised-button
        color="primary">
        Get Report
      </button>

      <div *ngIf="!newCustSubInvoice" style="margin-top: 20px" class="tableFixHead">
        <button type="button" (click)="exportexcel()" class="btn btn-danger">
          Export
        </button>
        <table class="table table-striped text-center">
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>Invoice No</th>
              <th>Invoice Date</th>
              <th>Client Name</th>
              <th>Total Amount</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let book of this.CustSubInvoiceData; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ book["invoice_id"] }}</td>
              <td>{{ book["invoice_date"] | date: "dd-MM-yyy" }}</td>
              <td>{{ book["name"] }}</td>
              <td>{{ book["total_amount"] }}</td>
              <td>{{ book["status"] }}</td>
              <td>
                <button type="button" (click)="ViewCustInvoiceSubscription(book)" class="btn btn-danger">
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </mat-tab>




    <!-- <mat-tab label="Subscription Business Report">
      <mat-form-field appearance="fill" style="margin-top: 5%">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [formGroup]="rangerepwisereport" [rangePicker]="picker2">
          <input matStartDate formControlName="start" placeholder="Start date" />
          <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getRepwiseReport()" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-date-range-picker #picker2></mat-date-range-picker>

        <mat-error *ngIf="
            rangerepwisereport.controls.start.hasError('matStartDateInvalid')
          ">Invalid start date
        </mat-error>
        <mat-error *ngIf="rangerepwisereport.controls.end.hasError('matEndDateInvalid')">Invalid end date
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" style="margin-left: 3%">
        <mat-label>Representative Name</mat-label>
        <mat-select name="rep" (selectionChange)="getSelectedRepdetails($event)">
          <mat-option *ngFor="let rep of getAllRepList" [value]="rep['id']">
            {{ rep["name"] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button style="margin-left: 3%" (click)="getRepWiseReport1()" mat-raised-button color="primary">
        Get Report
      </button>

      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important" id="excel-table">
        <div style="margin-top: 20px" class="tableFixHead">
          <button type="button" (click)="exportexcel('Subscribers_Bussiness_report')" class="btn btn-danger">
            Export
          </button>
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>प्रतिनिधींचे नाव</th>
                <th>विभाग</th>
                <th>ठिकाण</th>
                <th>मासिकाचे नाव</th>
                <th>Plan</th>
                <th>ग्राहक संख्या</th>
                <th>रक्कम</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let book of this.repwiseReport; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ book["rep_name"] }}</td>
                <td>{{ book["subcity"] }}</td>
                <td>{{ book["taluka"] }}</td>
                <td>{{ book["magname"] }}</td>
                <td>{{ book["Plan"] }}</td>
                <td>{{ book["cust_count"] }}</td>
                <td>{{ book["totalamount"] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab> -->

    <!-- <mat-tab label="Subscription Renewal Report">
      <mat-card>
        <form [formGroup]="subRenewalReportForm">
          <div class="form-row">
            <mat-form-field appearance="fill" style="margin-top: 1%; width: 30%;">
              <mat-label>Select a date range</mat-label>
              <mat-date-range-input [rangePicker]="pickersubrenewaldate">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateofSubRenewalReport()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickersubrenewaldate"></mat-datepicker-toggle>
              <mat-date-range-picker #pickersubrenewaldate></mat-date-range-picker>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin-left: 3%; margin-top: 1%; width: 30%;">
              <mat-label>Representative Name</mat-label>
              <mat-select formControlName="rep_name" (selectionChange)="getsubRenewalrepnames($event)" multiple>
                <mat-option *ngFor="let option of filtereddaterepwiserep_name" [value]="option['rep_name']">{{
                  option["rep_name"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="example-full-width" style="margin-left: 3%; margin-top: 1%; width: 30%;">
              <mat-label>Office Representative Name</mat-label>
              <input matInput formControlName="off_rep_name" [matAutocomplete]="autooff_rep_name" />
              <mat-autocomplete autoActiveFirstOption #autooff_rep_name="matAutocomplete" multiple>
                <mat-option (onSelectionChange)="getsubRenewaloff_rep_name($event, option)"
                  *ngFor="let option of filteredOptions22 | async" [value]="option['office_rep_name']">
                  {{ option["office_rep_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="fill" class="example-full-width" style=" margin-top: 1%; width: 30%;">
              <mat-label>District</mat-label>
              <input matInput formControlName="district" (keyup)="searchDistrict($event)"
                [matAutocomplete]="auto_district" />
              <mat-autocomplete autoActiveFirstOption #auto_district="matAutocomplete">
                <mat-option (onSelectionChange)="getsubRenewalDistrict($event, option)"
                  *ngFor="let option of filteredDistrictName" [value]="option['district_name']">
                  {{ option["district_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="fill" style="margin-left: 3%; margin-top: 1%; width: 30%;">
              <mat-label>Taluka</mat-label>
              <mat-select formControlName="taluka" (selectionChange)="getsubRenewalTalukaNames($event)">
                <mat-option *ngFor="let option of filteredTalukasName" [value]="option['taluka_name']">{{
                  option["taluka_name"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </form>
        <div style="display: flow-root;">
          <button mat-raised-button color="primary" (click)="renewablereceiptdata()">
            Renew Remaining data
          </button>
          <button style="margin-left: 2%;width: 340px;" mat-raised-button color="primary" (click)="subrenewalletter()">
            Subscription Renewal Remainder Letter
          </button>
        </div>
      
      </mat-card>

    </mat-tab> -->

    <!-- new tab -->



    <!-- <mat-tab label="Renewal Report">
      <mat-card>
        <form [formGroup]="renewalreportForm">
          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 7%; width: 40%">
              <mat-label>Enter a date from...to </mat-label>
              <mat-date-range-input [rangePicker]="pickerrr">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getRenewReportDateRange()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerrr"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerrr></mat-date-range-picker>

              <mat-error *ngIf="renewalreportForm.controls.start.hasError('matStartDateInvalid')
                                      ">Invalid start date</mat-error>
              <mat-error *ngIf="renewalreportForm.controls.end.hasError('matEndDateInvalid')">Invalid end date
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 7%; width: 40%">
              <mat-label>Representative Name</mat-label>
              <input matInput formControlName="rep" (keyup)="getRepNames($event)" [matAutocomplete]="autorepname1" />
              <mat-autocomplete autoActiveFirstOption #autorepname1="matAutocomplete">
                <mat-option (onSelectionChange)="selected_rep_names($event, option)"
                  *ngFor="let option of rep_name_data" [value]="option['repname']">
                  {{ option["repname"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </form>
       

        <div>
          <button mat-raised-button color="primary" style="margin-left: 10%;margin-top: 2%;"
            (click)="getAddressDistrictwiseStatement()">
            Districtwise Statement
          </button>
          <button mat-raised-button color="primary" style="margin-left: 2%;margin-top: 2%;"
            (click)="getRenewPincodewiseStatement()">Pincodewise Statement</button>
        </div>
      </mat-card>
    </mat-tab> -->

    <mat-tab label="Representativewise Address">
      <mat-card>
        <button mat-raised-button color="primary" (click)="representativewiseadd()">Representativewise
          Address</button>
        <div class="tableFixHead" style="margin-top: 20px;">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>नाव</th>
                <th>ठिकाण</th>
                <th>मो. नं.</th>
                <th>वर्गणीदार संख्या</th>
                <th>चालू</th>
                <th>बंद</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of repaddresslist">
                <td>{{item['rep_name']}}</td>
                <td>{{item['district']}}</td>
                <td>{{item['rep_mob_no']}}</td>
                <td>{{item['sub_count']}}</td>
                <td>{{item['sub_on']}}</td>
                <td>{{item['sub_off']}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>
    </mat-tab>

    <!-- <mat-tab label="Subscribers Address">
      <mat-card>
        <form [formGroup]="subaddform">
          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 1%; width: 40%; margin-top: 20px">
              <mat-label>Enter a date from...to </mat-label>
              <mat-date-range-input [rangePicker]="pickeras">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getSubAddressDateRange()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickeras"></mat-datepicker-toggle>
              <mat-date-range-picker #pickeras></mat-date-range-picker>

              <mat-error *ngIf="
                subaddform.controls.start.hasError('matStartDateInvalid')
              ">Invalid start date</mat-error>
              <mat-error *ngIf="subaddform.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 1%; margin-top: 2%;width: 40%;">
              <mat-label>Titles</mat-label>
              <mat-select formControlName="titles" (selectionChange)="gettitles($event)">
                <mat-option *ngFor="let option of titles1" [value]="option['title']">{{ option["title"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 1%; margin-top: 2%;width: 40%;">
              <mat-label>District</mat-label>
              <mat-select formControlName="district" (selectionChange)="getdistrict($event)">
                <mat-option *ngFor="let option of district" [value]="option['district']">{{ option["district"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 1%; margin-top: 2%;width: 40%;">
              <mat-label>Taluka</mat-label>
              <mat-select formControlName="taluka" (selectionChange)="gettaluka($event)">
                <mat-option *ngFor="let option of taluka" [value]="option['taluka']">{{ option["taluka"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 1%; margin-top: 2%;width: 40%;">
              <mat-label>Subscription Type</mat-label>
              <mat-select formControlName="subtype" (selectionChange)="getsubtype($event)">
                <mat-option *ngFor="let option of subtype" [value]="option['subtype']">{{ option["subtype"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 1%; margin-top: 2%;width: 40%;">
              <mat-label>Complimentary</mat-label>
              <mat-select formControlName="complimentary" (selectionChange)="getcomplimentary($event)">
                <mat-option value="Y">Yes</mat-option>
                <mat-option value="N">No</mat-option>
                <mat-option *ngFor="let option of complimentary" [value]="option['complimentary']">{{
                  option["complimentary"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </form>
        <button mat-raised-button color="primary" (click)="subAddress()">Subscriber Address</button>
      </mat-card>
    </mat-tab> -->

    <mat-tab label="Districtwise Pincode List">
      <mat-form-field appearance="fill" class="example-form-field" style="margin-top: 5%">
        <mat-label>Select Date for All Report</mat-label>
        <input matInput [(ngModel)]="newDistEndDate" [matDatepicker]="datepicker"
          (dateChange)="getChangedDate($event)" />
        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
        <mat-datepicker #datepicker> </mat-datepicker>
      </mat-form-field>

      <span style="margin-left: 3%; font-size: large; font-weight: bold">
        OR
      </span>

      <mat-form-field appearance="fill" style="margin-top: 5%; margin-left: 3%">
        <mat-label>Enter a date range for Weekly Report</mat-label>
        <mat-date-range-input [formGroup]="DistPinReport" [rangePicker]="picker5">
          <input matStartDate formControlName="start" placeholder="Start date" />
          <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getDisctdates()" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
        <mat-date-range-picker #picker5></mat-date-range-picker>

        <mat-error *ngIf="DistPinReport.controls.start.hasError('matStartDateInvalid')">Invalid start date
        </mat-error>
        <mat-error *ngIf="DistPinReport.controls.end.hasError('matEndDateInvalid')">Invalid end date
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" style="margin-left: 3%">
        <mat-label>District Name</mat-label>
        <mat-select #mySel (selectionChange)="getLabelSubDisct($event)" multiple>
          <mat-option [value]="{ city: 'all' }" (click)="toggleAllSelection()">All</mat-option>
          <mat-option *ngFor="let brp of districtList" [value]="brp">{{ brp["city"] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button style="margin-left: 3%" (click)="getPincodeWiseReports()" mat-raised-button color="primary">
        Get Report
      </button>

      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important" id="excel-table">
        <div style="margin-top: 20px" class="tableFixHead">
          <button type="button" (click)="exportexcel('Districtwise_Pincode_list')" class="btn btn-danger">
            Export
          </button>
          <table class="table table-striped text-center">
            <caption>
              Showing Data for :
              {{
              district_strings
              }}
            </caption>
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>पिनकोड</th>
                <th>वर्गणीदार संख्या</th>
                <th>जिल्हा</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let book of this.pincodeWiseSub; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ book["pincode"] }}</td>
                <td>{{ book["sub_count"] }}</td>
                <td>{{ book["city"] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>

    //Dengi Report
    <mat-tab label="Dengi Report">
      <mat-card class="expense">
        <form [formGroup]="expense">
          <h3 class="text-center" style="font-size: 25px;">DENGI REPORT</h3>
          <div class="form-row" style="margin-top: 10px;">
            <mat-form-field appearance="outline" style="margin-left: 2%; width: 15%">
              <mat-label>Start Date</mat-label>
              <input matInput type="date" formControlName="start" />
            </mat-form-field>

            <span class="date-separator" style="margin-left: 1%;margin-top: 15px;">-</span>

            <mat-form-field appearance="outline" style="margin-left: 1%;width: 15%">
              <mat-label>End Date</mat-label>
              <input matInput type="date" formControlName="end" (blur)="expenseledgerDateRange()" />
            </mat-form-field>
            <mat-form-field style="margin-left: 2%; width: 30%" class="example-full-width" appearance="outline">
              <mat-label>Select Main Expense</mat-label>
              <mat-select formControlName="expnameother" (selectionChange)="getSubExpByMainExp($event)">
                <mat-option *ngFor="let exp of mainExpData" [value]="{ id: exp['id'], source: exp['source'] }">
                  {{ exp["exp_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="subexpense" style="margin-left: 2%; width: 30%" class="example-full-width"
              appearance="outline">
              <mat-label>Select Sub Expense</mat-label>
              <mat-select formControlName="subexpnameother" (selectionChange)="getSubExpName1($event)">
                <mat-option *ngFor="let exp of subExpData" value="{{ exp['sub_id'] }}">{{ exp["sub_exp_name"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <button style="margin-left: 30%; width: 30%;margin-top: 20px;margin-bottom: 20px;" type="button"
              [disabled]="expense.invalid" mat-raised-button color="primary" (click)="expense_report_new()">
              Get Report
            </button>
          </div>
        </form>
      </mat-card>

    </mat-tab>


    <mat-tab label="Magzine ID Master">
      <mat-card>
        <form [formGroup]="addMagzineMaster"
          (ngSubmit)="ids_magzine_update_btn ? updateMagzineIdEntry() : addMagzineMasterId()">

          <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%" class="example-full-width">
            <mat-label>ID</mat-label>
            <input matInput formControlName="idname" />
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
            <mat-label>Delivery Mode</mat-label>
            <mat-select #mySel10 formControlName="delivery_mode_name" (selectionChange)="getmode_name($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelection10()">All</mat-option>
              <mat-option *ngFor="let option of LabelsDispatchDeliveryModes" [value]="option['mode_name']">{{
                option["mode_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="mode_names" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_delivery_mode_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>	

          <!-- Show Save button ONLY when NOT in edit mode -->
          <button *ngIf="!ids_magzine_update_btn" class="btn btn-primary" mat-raised-button color="primary"
            style="margin-left: 9%; width: 10%; margin-top: 2%; margin-right: 40%;" type="submit">
            Save
          </button>

          <!-- Show Update + Cancel buttons ONLY when in edit mode -->
          <ng-container *ngIf="ids_magzine_update_btn">
            <button mat-raised-button color="primary" style="margin-left: 30%; width: 10%; margin-top: 2%;"
              type="submit">
              Update
            </button>
            <button mat-raised-button color="warn" style="margin-left: 1%; width: 10%; margin-top: 2%;" type="button"
              (click)="cancelMagzineEdit()">
              Cancel
            </button>
          </ng-container>
        </form>

        <div class="tableFixHead1" style="padding: 20px 20px;">
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="text-align: center;">Sr no</th>
                <th style="text-align: center;">ID's</th>
                <th style="text-align: center;">Delivery Mode</th>
                <!-- <th style="text-align: center;">Added Date Time</th> -->
                <th style="text-align: center;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of magzineMasterIDSData; let i = index">
                <td style="text-align: center;">{{ i + 1 }}</td>
                <td style="text-align: center;">{{ item['id_Name'] }}</td>
                <td style="text-align: center;">{{ item['delivery_mode_name'] }}</td>
                <!-- <td style="text-align: center;">{{ item['Added_Date_Time'] }}</td> -->
                <td style="text-align: center;">
                  <button style="margin-right: 2%;" matTooltip="update" class="btn-sm btn-outline-info"
                    (click)="updateMagzineId(item)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button matTooltip="delete" class="btn-sm btn-outline-danger" (click)="deleteMagzineIDS(item['id'])">
                    <!-- <mat-icon>close</mat-icon> -->
                     <mat-icon class="fa-solid fa-trash"></mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>
    </mat-tab>

     // Excel Column Master For Magzine 
      <mat-tab label="Excel Magzine Column Master">
      <mat-card>
        <form [formGroup]="addExcelMagzineMaster"
          (ngSubmit)="excel_col_magzine_update_btn ? updateExcelColMagzineMaster() : addExcelColMagzineMaster()">
    
          <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%" class="example-full-width">
            <mat-label>Column Name</mat-label>
            <input matInput formControlName="colName" />
          </mat-form-field>

          <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%" class="example-full-width">
            <mat-label>Field Name </mat-label>
            <input matInput formControlName="fieldName" />
          </mat-form-field>

           <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
            <mat-label>Delivery Mode</mat-label>
            <mat-select #mySel10 formControlName="delivery_mode_name" (selectionChange)="getmode_name($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelection10()">All</mat-option>
              <mat-option *ngFor="let option of LabelsDispatchDeliveryModes" [value]="option['mode_name']">{{
                option["mode_name"]
                }}</mat-option>
            </mat-select>
            <button *ngIf="mode_names" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_delivery_mode_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
    
          <!-- Show Save button ONLY when NOT in edit mode -->
          <button *ngIf="!excel_col_magzine_update_btn" class="btn btn-primary" mat-raised-button color="primary"
            style="margin-left: 9%; width: 10%; margin-top: 2%; margin-right: 40%;" type="submit">
            Save
          </button>
    
          <!-- Show Update + Cancel buttons ONLY when in edit mode -->
          <ng-container *ngIf="excel_col_magzine_update_btn">
            <button mat-raised-button color="primary" style="margin-left: 30%; width: 10%; margin-top: 2%;" type="submit">
              Update
            </button>
            <button mat-raised-button color="warn" style="margin-left: 1%; width: 10%; margin-top: 2%;" type="button"
              (click)="cancelExcelMagzineEdit()">
              Cancel
            </button>
          </ng-container>
        </form>
    
        <div class="tableFixHead1" style="padding: 20px 20px;">
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="text-align: center;">Sr no</th>
                <th style="text-align: center;">Column Name</th>
                <th style="text-align: center;">Field Name</th>
                <th style="text-align: center;">Delivery Mode</th>
                <!-- <th style="text-align: center;">Added Date Time</th> -->
                <th style="text-align: center;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of excelMagzineMasterData; let i = index">
                <td style="text-align: center;">{{ i + 1 }}</td>
                <td style="text-align: center;">{{ item['col_name'] }}</td>
                <td style="text-align: center;">{{ item['field_Name'] }}</td>
                <td style="text-align: center;">{{ item['delivery_mode_name'] }}</td>
                <!-- <td style="text-align: center;">{{ item['Added_Date_Time'] }}</td> -->
                <td style="text-align: center;">
                  <button style="margin-right: 2%;" matTooltip="update" class="btn-sm btn-outline-info"
                    (click)="updateExcelColMagzine(item)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button matTooltip="delete" class="btn-sm btn-outline-danger" (click)="deleteExcelMagzineCol(item['id'])">
                    <!-- <mat-icon>close</mat-icon> -->
                     <mat-icon class="fa-solid fa-trash"></mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>
    </mat-tab>	


    <!-- <mat-tab label="Actvity Log">
      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important" id="excel-table">
        <div style="margin-top: 20px" class="tableFixHead">
          <button type="button" (click)="exportexcel('Activity_log')" class="btn btn-danger">
            Export
          </button>
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>ग्राहक क्र.</th>
                <th>Activity</th>
                <th colspan="2">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let book of this.Notifications; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ book["sub_id"] }}</td>
                <td>{{ book["msg"] }}</td>
                <td>
                  <button *ngIf="book['msg'].indexOf('Renew') &gt;= 0" type="button" class="btn btn-danger btn-sm"
                    (click)="View_renewal_details(book['sub_id'])">
                    View
                  </button>
                  <button *ngIf="book['msg'].indexOf('Update') &gt;= 0" type="button" class="btn btn-danger btn-sm"
                    (click)="mark_as_read(book['id'])">
                    Mark As Read
                  </button>
                  <button *ngIf="book['msg'].indexOf('Activation') &gt;= 0" type="button" class="btn btn-success btn-sm"
                    (click)="activate_user(book['sub_id'])">
                    Activate
                  </button>
                </td>
                <td>
                  <button *ngIf="book['msg'].indexOf('Activation') &gt;= 0" type="button" class="btn btn-danger btn-sm"
                    (click)="view_user_details(book['sub_id'])">
                    View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab> -->

    <!-- <mat-tab label="Subscription Account">
     
      <mat-card style="margin-top: 2%;">
        <form [formGroup]="subledgerForm">
          <div class="form-row">
            <mat-form-field appearance="fill" class="example-full-width"
              style="margin-left: 1%; margin-top: 0.5%; width: 35%;">
              <mat-label>Subscriber Name</mat-label>
              <input matInput formControlName="sub_name" [matAutocomplete]="autooff_sub_name" />
              <button *ngIf="sub_name1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_sub_name1()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete autoActiveFirstOption #autooff_sub_name="matAutocomplete">
                <mat-option (onSelectionChange)="getsub_name1($event, option)"
                  *ngFor="let option of filteredOptions23 | async" [value]="option['sub_name']">
                  {{ option["sub_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="fill" class="example-full-width"
              style="margin-left: 5%; margin-top: 0.5%; width: 20%;">
              <mat-label>Subscriber No</mat-label>
              <input matInput formControlName="sub_no" [matAutocomplete]="auto_sub_no" />
              <button *ngIf="sub_no1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_sub_no1()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete autoActiveFirstOption #auto_sub_no="matAutocomplete">
                <mat-option (onSelectionChange)="getsub_no1($event, option)"
                  *ngFor="let option of filteredOptions24 | async" [value]="option['sub_no']">
                  {{ option["sub_no"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="fill" style="margin-top: 1%; margin-left: 1%;width: 35%;">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [rangePicker]="pickerdatesubledger">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDatesubledger()" />
              </mat-date-range-input>
              <mat-datepicker-toggle *ngIf="!subledgerstartDate && !subledgerendDate" matSuffix
                [for]="pickerdatesubledger"></mat-datepicker-toggle>
              <button *ngIf="subledgerstartDate && subledgerendDate" matSuffix mat-icon-button aria-label="Clear"
                (click)="reset_Datesubledger()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-date-range-picker #pickerdatesubledger></mat-date-range-picker>
            </mat-form-field>
          </div>
        </form>
        <div class="tableFixHead">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>वर्गणी पावती क्र</th>
                <th>वर्गणी पावती दिनांक</th>
                <th>वर्गणी प्रकार</th>
                <th>वर्गणी कालावधी</th>
                <th>वर्गणी रक्कम</th>
                <th>बँक डिटेल्स</th>
                <th>प्रतिनिधीचे नाव</th>
                <th>Delivery Mode</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Filteredsubscribersledgerdata">
                <td>{{item['rcpt_no']}}</td>
                <td>{{item['entry_date'] | date:"dd-MM-yyy"}}</td>
                <td>{{item['subtype']}}</td>
                <td>{{item['sub_perid_from_date'] | date:"dd-MM-yyy"}} - {{item['sub_perid_to_date'] |
                  date:"dd-MM-yyy"}}</td>
                <td>{{item['total_amt']}}</td>
                <td><span *ngIf="item['cheque_draft_no'] != 0">
                    {{item['bank_name']}}
                    {{item['cheque_draft_no']}}
                  </span>
                  <span *ngIf="item['cheque_draft_no'] == 0">
                    Cash
                  </span>
                </td>
                <td>{{item['rep_name']}}</td>
                <td>{{item['delivery_mode']}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <mat-paginator (page)="
        lePageEvent2($event)" [length]="length2" [pageSizeOptions]="[500, 1000, 2000]"
          showFirstLastButtons aria-label="Select page of periodic elements">
        </mat-paginator>
      </mat-card>
    </mat-tab> -->








    <!-- <mat-tab label="Subscription Representative">
      <mat-card style="margin-top: 20px">
        <table class="table table-striped table-fixed">
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Representative Name</th>
              <th>Representative Mobile No</th>
              <th>Representative District</th>
              <th>Office Representative</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of subscriberwisereplist1; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item["rep_name"] }}</td>
              <td>{{ item["rep_mob_no"] }}</td>
              <td>{{ item["district"] }}</td>
              <td>{{ item["off_rep_name"] }}</td>
              <td>
                <button type="button" class="btn-sm btn-outline-info" matTooltip="Update" (click)="update(item)">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </mat-card>
    </mat-tab> -->
  </mat-tab-group>


</div>